import React from 'react';
import './App.css';
import logos from './logos.svg';
import users from './users.svg';
import firebase from "firebase/app";
import { Component, createContext, useState, useEffect, useRef, useContext, useCallback, useLayoutEffect, Suspense,createRef }  from 'react';
import { View, Text, TextInput, FlatList, TouchableOpacity} from 'react-native';
import slide_2 from './images/slide_2.png';
import raphael from './raphael.jpg';
import entrepreneur from './entrepreneur.png';
import slide_3 from './images/slide_3.png';
import admin from './admin.png';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ExploreRoundedIcon from '@material-ui/icons/ExploreRounded';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Link, Router, useParams, navigate } from "@reach/router";
import SendIcon from '@material-ui/icons/Send';
import ChatIcon from '@material-ui/icons/Chat';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import SaveIcon from '@material-ui/icons/Save';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';
import SlideShows from './SlideShow.js';
import AddStatus from './AddStatus.js';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import AddPost from './AddPost.js';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import MenuItem from '@material-ui/core/MenuItem';
import HomePageScreen from './Homepage';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import Chip from '@material-ui/core/Chip';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartBroken } from '@fortawesome/free-solid-svg-icons';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import DeleteIcon from '@material-ui/icons/Delete';
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import { useObject } from 'react-firebase-hooks/database';
import ForumIcon from '@material-ui/icons/Forum';
import ExploreIcon from '@material-ui/icons/Explore';
import PostInfo from './postInfo.js';





const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '100%',
      
    },
     },
      button: {
    margin: theme.spacing(1),
  },
    modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },

}));
 
 

const firebaseConfig = {
 apiKey: "AIzaSyDqmQJInS_ggTQdG3Q9lJ6_vGRgO2q8myQ",
  authDomain: "e-learnershub.firebaseapp.com",
  databaseURL: "https://e-learnershub.firebaseio.com",
  projectId: "e-learnershub",
  storageBucket: "e-learnershub.appspot.com",
  messagingSenderId: "559652460186",
  appId: "1:559652460186:web:288c663f4f265ccf667123",
  measurementId: "G-BW9FSF4NM6"
};
// Initialize Firebase
if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

function App() {
  const [data, setData] = useState(null);

//  var user = firebase.auth().currentUser;


  useEffect(() => {

    firebase.auth().getRedirectResult().then(function(result) {
      if (result.credential) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // ...
      }
      // The signed-in user info.
      var user = result.user.displayName;
      setData(result.user);
      setData(user);
      console.log('users', data);
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    

         }, [])

         const [initializing, setInitializing] = useState(true);
    const [user, setUser] = useState(null);

    //used to set the user details to the global variable user, which can be called anywhere in the code
     function onAuthStateChanged(user) {
                setUser(user);
                    if (initializing) setInitializing(false);
     }
    
     //used to set te user variabl   e anytime the app launches
    useEffect(() => {
        const subscriber = firebase.auth().onAuthStateChanged(onAuthStateChanged);

        return subscriber;
    }, [onAuthStateChanged]);

    if (initializing) {
      return <p> please, wait a bit while we authenticate your presence</p>
    }

         
            if (user) {
              // User is signed in.
              navigate('');
              return <Apps className="App" />
              } else {
              // No user is signed in.
              return <HomePageScreen className="App"/>
              } 
}


export default App;



  
  

function Apps () {

        const [data, setData] = useState('');





  useEffect(() => {

    firebase.auth().getRedirectResult().then(function(result) {
      if (result.credential) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // ...
      }
      // The signed-in user info.
      var user = result.user.displayName;
      setData(result.user);
      setData(user);
      console.log('users', data);
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });

         })

         const [loading, setLoading] = useState(true); // Set loading to true on component mount
  const [userss, setUserss] = useState([]); 
  const [errors, setErrors]= useState('');

  const [visible, setVisible] = useState(true);

  var provider = new firebase.auth.GoogleAuthProvider();
  firebase.auth().useDeviceLanguage();

  
  


useEffect(() => {

firebase.auth().getRedirectResult().then(function(result) {
  if (result.credential) {
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = result.credential.accessToken;
    var user = result.user.displayName;
    var photoURL = result.user.photoURL;
    setData(user);
    setVisible(photoURL);

    
    // ...
  }
  // The signed-in user info.
 
}).catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // The email of the user's account used.
  var email = error.email;
  // The firebase.auth.AuthCredential type that was used.
  var credential = error.credential;
  setErrors(errorMessage);
  // ...
});

 

     }, [user])

     var user = firebase.auth().currentUser;
     

const [userData, setUserData] = useState([]);
const [id, setId] = useState('');

const [threads, setThreads] = useState([]);
const [loaded, setLoaded] = useState(false);
const [users, setUsers] = useState('');

const [ display, setDisplay ] = useState('flex');



    useEffect(() => {

firebase.database()
.ref('/User/' + user.uid )
.update({
  
 
    createdAt: new Date().getTime(),
    uid: user.uid,
    email: user.email,
    
   
  
});
// Get the token
if(user.email.includes('gmail.com')) {

firebase.database()
.ref('/User/' + user.uid )
.update({
  User: 'Student',
  photoURL: user.photoURL,
    displayName: user.displayName,
  
});
}else if (user.email.includes("@learnershub.com")) {

firebase.database()
.ref('/User/' + user.uid )
.update({
  User: 'Business',
  
});
}else {
firebase.database()
.ref('/User/' + user.uid )
.update({
  User: 'School',
  
});

}


},[user]);



const [universityName, setUniversityName] = useState('');
    const [complete, setComplete] = useState('');
    const [userProfile, setUserProfile] = useState('');
    const [universityUid, setUniversityUid] = useState('');
    const [courseName, setCourseName] = useState('');
    const [startYear, setStartYear] = useState('');
    const [endYear, setEndYear] = useState('');
    const [matricNo, setMatricNo] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [location, setLocation] = useState('');
    const [school, setSchool] = useState('');
    const [displayPicture, setDisplayPicture] = useState('');
    const [currentState, setCurrentState] = useState('');
    const [business, setBusiness] = useState('');
    const [postCount, setPostCount] = useState('');

    const [waiting, setWaiting] = useState(true);


    const [online, setOnline] = useState([]);
    const [userids, setUserids] = useState([]);

    const [schoolYear, setSchoolYear]= useState('');
    const [communityWaiting, setCommunityWaiting] = useState(true);
    const [schoolYearList, setSchoolYearList] = useState([]);
    const [yearProps, setYearProps] = useState('');
    const [businessCommunityList, setBusinessCommunityList] = useState([]);
const [schoolCommunityList, setSchoolCommunityList] = useState([]);

const [insideChatRoomProps, setInsideChatRoomProps] = useState('');
const [insideChatRoomData, setInsideChatRoomData] = useState('');


/*





const schoolCommunity =  firebase.database().ref('/User/' + `/${props.uid}/` + '/Year/' + `/${schoolYear}/` );
const [schoolSnapshots, schoolLoadings, schoolError] = useObject(schoolCommunity );


  
 
const businessCommunity = firebase.database().ref('/User/' + `/${props.uid}/` + '/Communities/' );
const [snapshots, loadings, error] = useObject(schoolYear );
console.log(snapshots);
*/

/*used to read data to important dashboard in insideScreen*/
   useEffect(() => {

        const onChildAdd = firebase.database().ref('/User/' + `/${yearProps}/` + '/Year/' + `/${schoolYear}/` + `/${insideChatRoomProps}/` ).orderByChild('createdAt').on('value', function(snapshot) {
const years = [];
    snapshot.forEach(function(userSnapshot) {
        const id = userSnapshot.key;
        const year = userSnapshot.val();
        years.push(year);
    });

setInsideChatRoomData(years);
 setCommunityWaiting(false);
});


 return () =>
    firebase.database().ref('/User/' + `/${yearProps}/` + '/Year/' + `/${schoolYear}/` + `/${insideChatRoomProps}/`)
        .off('value', onChildAdd);


}, [insideChatRoomProps]);


   useEffect(() => {

        const onChildAdd = firebase.database().ref('/User/' + `/${yearProps}/` + '/Year/').on('value', function(snapshot) {
const years = [];
    snapshot.forEach(function(userSnapshot) {
        const id = userSnapshot.key;
        const year = userSnapshot.val();
        years.push(year);
    });

setSchoolYearList(years);
setUserids(userids);
 setCommunityWaiting(false);
});


 return () =>
    firebase.database().ref('/User')
        .off('value', onChildAdd);


}, [yearProps]);
       

   useEffect(() => {

        const onChildAdd = firebase.database().ref('/User/' + `/${yearProps}/` + '/Year/' + `/${schoolYear}/` ).on('value', function(snapshot) {
const years = [];
    snapshot.forEach(function(userSnapshot) {
        const id = userSnapshot.key;
        const year = userSnapshot.val();
        years.push(year);
    });

setSchoolCommunityList(years);
 setCommunityWaiting(false);
});


 return () =>
    firebase.database().ref('/User')
        .off('value', onChildAdd);


}, [yearProps, schoolYear]);

useEffect(() => {

        const onChildAdd = firebase.database().ref('/User/' + `/${yearProps}/` + '/Communities/'  ).on('value', function(snapshot) {
const years = [];
    snapshot.forEach(function(userSnapshot) {
        const id = userSnapshot.key;
        const year = userSnapshot.val();
        years.push(year);
    });

setBusinessCommunityList(years);
 setCommunityWaiting(false);
});


 return () =>
    firebase.database().ref('/User')
        .off('value', onChildAdd);


}, [yearProps]);



    useEffect(() => {

        const onChildAdd = firebase.database().ref('/User').on('value', function(snapshot) {
const online = [];
const userids = [];
snapshot.forEach(function(userSnapshot) {
const id = userSnapshot.key;
const message = userSnapshot.val();
userids.push(id);
online.push(message);
});
setOnline(online);
setUserids(userids);
 setWaiting(false);
});


 return () =>
    firebase.database().ref('/User')
        .off('value', onChildAdd);


}, [yearProps]);
     
   
    
    useEffect(() => { 
      const onValueChange = firebase.database().ref('/User/' + user.uid ).on('value', function(snapshot) {
    setUniversityName(university => snapshot.val().University);
    setComplete(complete => snapshot.val().Complete);
    setUserProfile(userProfile => snapshot.val().User);
    setUniversityUid(universityUid => snapshot.val().UniversityUid);
    setCourseName(snapshot.val().Course);
    setStartYear(snapshot.val().StartYear);
    setEndYear(snapshot.val().EndYear);
    setMatricNo(snapshot.val().MatricNo);
    setDisplayName(snapshot.val().displayName);
    setLocation(snapshot.val().Country);
    setSchool(snapshot.val().School);
    setDisplayPicture(snapshot.val().photoURL);
    setCurrentState(snapshot.val().State);
    setBusiness(snapshot.val().Business);
     setPostCount(snapshot.val().postCount);

    // ...
    });
    
     setWaiting(false);

    
     return () =>
      firebase.database()
        .ref(`/User/${user.uid}`)
        .off('value', onValueChange);
    }, [user.uid])

const [coursesList, setCoursesList] = useState([]);


 useEffect(() => {

    const onChildAdd = firebase.database().ref('/Course' ).orderByChild('createdAt').on('value', function(snapshot) {
const courseVideoList = [];

snapshot.forEach(function(userSnapshot) {
const id = userSnapshot.key;
const list = userSnapshot.val();

courseVideoList.push(list);



});
 
setCoursesList(courseVideoList);

});



console.log(coursesList);


 return () =>
    firebase.database().ref('/Course/' )
        .off('value', onChildAdd);


}, []);



         const [searchQuery, setSearchQuery] = useState('');

        const onChangeSearch = (event) => {
    setSearchQuery(event.target.value);
  };

           
        const [searchSchool, setSchoolSearch] = useState('');

   

   const onChangeSchoolSearch = (event) => {
    setSchoolSearch(event.target.value);
  };






function NewUser () {


  function StudentsAddLevel() {
     const [matric, setMatric] = useState('');

        const [level, setLevel] = useState('');
        const [disabled, setDisabled] = useState(true);

     
        useEffect(() => {
          if (level < startYear) {
            setDisabled(true)
          }else if (level > endYear) {
            setDisabled(true)
          }else if (level.length != 4) {
            setDisabled(true)
          }else if (matric == ''){
            setDisabled(true)
          }else {
            setDisabled(false)
          }
       
        }, [level])



        
        useEffect(() => {
          if (matric == ''){
            setDisabled(true)
          }else if (level == '') {
              setDisabled(true)
          }else {
            setDisabled(false)
          }
        }, [matric])

         const handleMatricChange = (event) => {
    setMatric(event.target.value);
  };


         const handleLevelChange = (event) => {
    setLevel(event.target.value);
  };



        return(
          <div>
            <p>here is where you will add your Additional details about your school identity</p>
            <TextField
      label="School identification number"
      value={matric}
      onChange={handleMatricChange}
      autoFocus={true}
          error={false}
      
    />
<p> Must be between {startYear} and {endYear}</p>
<TextField
      label="Likely End year"
      value={level}
      onChange={handleLevelChange}
       type='number'
       autoFocus={true}
       error={false}
     
    />


    <Button 
    disabled = {disabled}
    onClick={() =>
    firebase.database()
        .ref('/User/' + user.uid )
        .update({
                      
            EndYear: '',
            StartYear: '',
            MatricNo: matric,
            Level: level,
            Complete: '',
            
        })
    }>Submit Data</Button>
          </div>
        )
      }


 function StudentsAddCourses() {

 const [courses, setCourses] = useState([]);

     
        useEffect(() => {
      
          const onChildAdd = firebase.database().ref('/User/' + `${universityUid}` + '/Faculty/' ).on('value', function(snapshot) {
      const courses =[];
      
      snapshot.forEach(function(userSnapshot) {
      const id = userSnapshot.key;
      const userData = userSnapshot.val();
      
      userData['uid'] = id;
      courses.push(userData);
      
      });
      setCourses(courses);
       
      
      });
          
       return () =>
          firebase.database().ref('/User/' + `${universityUid}` + '/Faculty/' )
              .off('value', onChildAdd);
      
      
      }, [universityUid]);
     
        return(
<div>
<p>{universityName} has been saved to the database, Learners Hub admins will have to delete your account if you entered a false School </p>
  <p>hi, this is where you will add your course</p>

   <TextField
      id="out-lined-number"
          label="Course-search"
         placeholder='search for your course'
          value={searchQuery}
          onChange={onChangeSearch}
         required
         fullWidth= {true}
        autoFocus={true}
          error={false}
        />
        

        <ul style ={{listStyleType: 'none', padding: 0, width: '100%'}}>
    {courses.map(function(item){
     
         return (
          <div key={item.StartYear}  style={{flex: 1, display: 'flex', width: '100%', justifyContent: 'flex-start', flexDirection:'row', alignItems: 'center'}}>

  {item.CourseName.includes(searchQuery)?       
          <li  onClick={() => firebase.database()
    .ref('/User/' + user.uid )
    .update({
           
      Faculty: item.Faculty,
            Course: item.CourseName,
            EndYear: item.currentEndYear,
            StartYear: item.StartYear,
            MatricNo: '',
            Complete: '',
    })}>
    <div style={{width: '100%', backgroundColor: 'lightgrey', borderColor: 'black', borderWidth: 2, borderStyle: 'solid',  marginTop: '3%', paddingLeft: '2%', paddingRight: '2%',  borderRadius: 10, justifyContent: 'flex-start', flexDirection: 'column'}} >
    <h5><b>{item.CourseName}</b></h5>
<p>{item.Faculty + '-> from ' + item.StartYear + ' to ' + item.currentEndYear}</p>
</div></li>
    : null}

                   
          </div>
    )
    })}
</ul>

  

</div>
        )
      }

      function CompleteSchoolDetails () {

        return(
          <div>
           
            <p> you have now completed filling in your school details, before we open up the chat system for you, please note the following</p>
            
            <Button 
    onClick={() =>
    firebase.database()
        .ref('/User/' + user.uid )
        .update({
                      
           
            Complete: true,
            
        })
    }>Start Chatting</Button>
        </div>)
      }
    
      
      

 
  
  

function StudentAdditional () {




  return(

<div className='community' style={{flex:1, backgroundColor: 'whiteSmoke', marginTop: '10%', padding: '2%', width: '90%', borderRadius: 10, justifyContent: 'center'}} >
      <p>you need to fill in your school details  (as an Alumni or current student) to use this section</p>
{!universityName ?<div>

     <TextField

      id="out-lined-number"
          label="School-search"
         placeholder='search for your school'
          value={searchSchool}
          onChange={onChangeSchoolSearch}
         required
         fullWidth= {true}
       autoFocus={true}
          error={false}
      
        />
         

<ul style ={{listStyleType: 'none', padding: 0}} >
    {online.map(function(item){
     
         return (
          <div   key={item.uid} style={{flex: 1, display: 'flex', width: '100%', justifyContent: 'center', flexDirection:'row', alignItems: 'center'}}>

  {item.User == 'School' ?<div>{item.displayName.includes(searchSchool)?
          
          <li  onClick={() => firebase.database()
    .ref('/User/' + user.uid )
    .update({
      
     
        University: item.displayName,
        UniversityUid: item.uid,
        Faculty: '',
        Course: '',
        Level: '',
        MatricNo: '',
        Complete: '',
        Student: 'true',
    })}>

<div style={{width: '100%', padding: '5%', justifyContent: 'flex-start', flexDirection:'row', alignItems: 'center', backgroundColor: 'lightgrey', borderRadius: 10, marginTop: '3%'}} ><Avatar src={item.photoURL}/> <div style={{ padding: '2%', width: '100%', flexDirection: 'column'}}><p><b>{item.displayName}</b></p> <p>{item.School} ---- {item.State}, {item.Country}</p></div>

</div>
    </li>
          : null}</div>
: null}
                   
          </div>
    )
    })}
</ul>
</div>
 :  !courseName ? <StudentsAddCourses/> : !matricNo ? <StudentsAddLevel/> : <CompleteSchoolDetails/>}


    </div>
  )
}

function BusinessAdditional () {

  const [businessName, setBusinessName] = useState('');
   const handleBusinessNameChange = (event) => {
    setBusinessName(event.target.value);
  };

  


  return (
    <div className='community' style={{flex:1, backgroundColor: 'whiteSmoke', marginTop: '10%', padding: '2%', width: '90%', borderRadius: 10, justifyContent: 'center'}} >
  <Text> this is where you should complete your business details</Text>
  <Text> please, to use the chat system, you need to complete your business details, you can complete it in less than a minute, you cant change these details</Text>
 
  <div style={{width: 'auto', backgroundColor: 'lightgrey', padding: '1%',  alignItems: 'center', borderRadius: 10, justifyContent: 'flex-start', flexDirection: 'row'}} >
<Avatar alt="X" src={displayPicture} />
 <div style={{padding: '3%', flexDirection: 'column', justifyContent: 'flex-start'}} ><Text>Your Business name is <b>{displayName}?</b></Text>
 <Text>{business}   {currentState}¤<b>{location}</b></Text>
 </div>
</div>

   { !displayName ? <div style={{ backgroundColor: 'lightgrey', marginTop: '5%', padding: '2%', flexDirection: 'column', justifyContent: 'flex-start'}} >
   {!displayPicture ? 
  
       <div style={{width: '100%', display: 'flex', flexDirection: 'column'}} >   
  
   <p> please upload your business logo for your potential customers to easily identify you</p>
  <form>
   <label className="btn btn-default">
          <input type="file"  onChange={handleImageAsFile}  accept="image/png, image/gif, image/jpeg" />
        </label>
        
     <IconButton aria-label="save"  onClick={sendImage}
  >
    <SendIcon />
  </IconButton> 
  
       
  
  </form>     
  </div>
  
  
    :null}
  
    <TextField
  
        id="out-lined-number"
            label="School Name"
           placeholder='type your school name'
            value={businessName}
            onChange={handleBusinessNameChange}
           required
           fullWidth= {true}
         autoFocus={true}
            error={false}
        
          />
  
  <Button 
  disabled = { !downloadURL ? true : !businessName ? true : false}
      onClick={() =>
      firebase.database()
          .ref('/User/' + user.uid )
          .update({
                        
              photoURL: downloadURL,
              displayName: businessName,
              
          })
      }>Save </Button>
      </div>
      : !location ? <SchoolLocation/>: <BusinessChoice/>}
  </div>
    )
  }


  
function BusinessChoice () {

  const [courses, setCourses] = useState([]);

  const [universityCourse, setUniversityCourse] = useState('');
const [universityFaculty, setUniversityFaculty] = useState('');
const [universityStartYear, setUniversityStartYear] = useState('');
const [universityEndYear, setUniversityEndYear] = useState('');


const handleCourseChange = (event) => {
    setUniversityCourse(event.target.value);
  };



const handleFacultyChange = (event) => {
    setUniversityFaculty(event.target.value);
  };


 const handleStartYearChange = (event) => {
    setUniversityStartYear(event.target.value);
  };


         const handleEndYearChange = (event) => {
    setUniversityEndYear(event.target.value);
  };


   const [disabled, setDisabled] = useState(true);

     
        useEffect(() => {
          if (universityStartYear.length != 4) {
            setDisabled(true)
          }else if (universityStartYear == ''){
            setDisabled(true)
          }else if (universityEndYear.length != 4) {
            setDisabled(true)
          }else {
            setDisabled(false)
          }
       
        }, [universityStartYear.length])

              useEffect(() => {
          if (universityEndYear.length != 4) {
            setDisabled(true)
          }else if (universityEndYear == ''){
            setDisabled(true)
          }else if (universityStartYear.length != 4) {
            setDisabled(true)
          }else {
            setDisabled(false)
          }
       
        }, [universityEndYear.length])

     
        useEffect(() => {
      
          const onChildAdd = firebase.database().ref('/User/' + `${user.uid}` + '/Faculty/' ).on('value', function(snapshot) {
      const courses =[];
      
      snapshot.forEach(function(userSnapshot) {
      const id = userSnapshot.key;
      const userData = userSnapshot.val();
      
      userData['uid'] = id;
      courses.push(userData);
      
      });
      setCourses(courses);
       
      
      });
          
       return () =>
          firebase.database().ref('/User/' + `${user.uid}` + '/Faculty/' )
              .off('value', onChildAdd);
      
      
      }, []);

       const [schoolChoice, setSchoolChoice] = React.useState('');

  const handleChoiceChange = (event) => {
    setSchoolChoice(event.target.value);
  };



      const [toggle, setToggle] = useState(null);

  const handleClick = (event) => {
    setToggle(event.currentTarget);
  };

  const handleClose = () => {
    setToggle(null);
  };

  const open = Boolean(toggle);
  const id = open ? 'simple-popover' : undefined;







  return(
  <div style={{width: '100%',  padding: '1%',  alignItems: 'center',  justifyContent: 'center', flexDirection: 'column'}} >






    { !business ?

      <div style={{width: 'auto', backgroundColor: 'lightgrey', padding: '3%',  alignItems: 'center', marginTop: '5%', borderRadius: 10, justifyContent: 'center', flexDirection: 'column'}} ><FormControl component="fieldset">
      <FormLabel component="legend" style={{width: 'auto', backgroundColor: 'grey', color: 'white', padding: '5%',  borderRadius: 5, }} >Type of Business</FormLabel>
      <RadioGroup aria-label="gender" name="gender1" value={schoolChoice} onChange={handleChoiceChange}>
        <FormControlLabel value="Digital content creator/management" control={<Radio />} label="Digital content creator/management" />
        <FormControlLabel value="Cosmetology" control={<Radio />} label="Cosmetics" />
        <FormControlLabel value="Fabric and textile production / sale" control={<Radio />} label="Clothing" />
        <FormControlLabel value="Merchandice"  control={<Radio />} label="Trading" />
      </RadioGroup>
    </FormControl>

      <TextField
  
        id="out-lined-number"
            label="or type yours"
           placeholder='type your school name'
            value={schoolChoice}
            onChange={handleChoiceChange}
           
            error={false}
        
          />

    <p> your business type is <b>{schoolChoice}</b>?</p>

    <Button

disabled={!schoolChoice ? true : false} 
    onClick={() =>
    firebase.database()
       .ref('/User/' + `${user.uid}` )
        .update({
                      
           Business: schoolChoice

            
        })
    }>submit</Button>

</div>
   : <div><Button 
    onClick={() =>
    firebase.database()
        .ref('/User/' + user.uid )
        .update({
                      
           
            Complete: true,
            
        })
    }>Start Chatting</Button>
      </div>}

</div>

  )
}


function SchoolAdditional () {

  const [businessName, setBusinessName] = useState('');
   const handleBusinessNameChange = (event) => {
    setBusinessName(event.target.value);
  };

  


  return (
    <div className='community' style={{flex:1, backgroundColor: 'whiteSmoke', marginTop: '10%', padding: '2%', width: '90%', borderRadius: 10, justifyContent: 'center'}} >
  <Text> this is where a school should complete its details</Text>
  <Text> please, to use the chat system, you need to complete your business details, you can complete it in less than a minute, you cant change these details</Text>
  
   { !displayName ? <div style={{ backgroundColor: 'lightgrey', marginTop: '5%', padding: '2%', flexDirection: 'column', justifyContent: 'flex-start'}} >
  
    {!displayPicture ? 
  
       <div style={{width: '100%', display: 'flex', flexDirection: 'column'}} >
   
  
   <Text> please upload your school's logo for your students to easily identify you</Text>
  <form>
   <label className="btn btn-default">
          <input type="file"  onChange={handleImageAsFile} accept="image/png, image/gif, image/jpeg" />
        </label>
        
     <IconButton aria-label="save"  onClick={sendImage}
  >
    <SendIcon />
  </IconButton> 
  
       
  
  </form>     
  </div>
  
  
    :null}
  
    <TextField
  
        id="out-lined-number"
            label="School Name"
           placeholder='type your school name'
            value={businessName}
            onChange={handleBusinessNameChange}
           required
           fullWidth= {true}
         autoFocus={true}
            error={false}
        
          />
  
  <Button 
  disabled = { !downloadURL ? true : !businessName ? true : false}
      onClick={() =>
      firebase.database()
          .ref('/User/' + user.uid )
          .update({
                        
              photoURL: downloadURL,
              displayName: businessName,
              
          })
      }>Save </Button>
      </div>
      : !location ? <SchoolLocation/>: <UniversityAddCourses/>}
  </div>
    )
  }


  


function UniversityAddCourses () {

  const [courses, setCourses] = useState([]);

  const [universityCourse, setUniversityCourse] = useState('');
const [universityFaculty, setUniversityFaculty] = useState('');
const [universityStartYear, setUniversityStartYear] = useState('');
const [universityEndYear, setUniversityEndYear] = useState('');


const handleCourseChange = (event) => {
    setUniversityCourse(event.target.value);
  };



const handleFacultyChange = (event) => {
    setUniversityFaculty(event.target.value);
  };


 const handleStartYearChange = (event) => {
    setUniversityStartYear(event.target.value);
  };


         const handleEndYearChange = (event) => {
    setUniversityEndYear(event.target.value);
  };


   const [disabled, setDisabled] = useState(true);

     
        useEffect(() => {
          if (universityStartYear.length != 4) {
            setDisabled(true)
          }else if (universityStartYear == ''){
            setDisabled(true)
          }else if (universityEndYear.length != 4) {
            setDisabled(true)
          }else {
            setDisabled(false)
          }
       
        }, [universityStartYear.length])

              useEffect(() => {
          if (universityEndYear.length != 4) {
            setDisabled(true)
          }else if (universityEndYear == ''){
            setDisabled(true)
          }else if (universityStartYear.length != 4) {
            setDisabled(true)
          }else {
            setDisabled(false)
          }
       
        }, [universityEndYear.length])

     
        useEffect(() => {
      
          const onChildAdd = firebase.database().ref('/User/' + `${user.uid}` + '/Faculty/' ).on('value', function(snapshot) {
      const courses =[];
      
      snapshot.forEach(function(userSnapshot) {
      const id = userSnapshot.key;
      const userData = userSnapshot.val();
      
      userData['uid'] = id;
      courses.push(userData);
      
      });
      setCourses(courses);
       
      
      });
          
       return () =>
          firebase.database().ref('/User/' + `${user.uid}` + '/Faculty/' )
              .off('value', onChildAdd);
      
      
      }, []);

       const [schoolChoice, setSchoolChoice] = React.useState('University');

  const handleChoiceChange = (event) => {
    setSchoolChoice(event.target.value);
  };



      const [toggle, setToggle] = useState(null);

  const handleClick = (event) => {
    setToggle(event.currentTarget);
  };

  const handleClose = () => {
    setToggle(null);
  };

  const open = Boolean(toggle);
  const id = open ? 'simple-popover' : undefined;








  return(
  <div>

<div style={{width: '100%', backgroundColor: 'lightgrey', padding: '1%',  alignItems: 'center', borderRadius: 10, justifyContent: 'flex-start', flexDirection: 'row'}} >
<Avatar alt="X" src={displayPicture} />
 <div style={{padding: '3%', flexDirection: 'column', justifyContent: 'flex-start'}} > <Text>Your school name is <b>{displayName}</b></Text>
 <Text>{school}   {currentState}¤<b>{location}</b></Text>
 </div>
</div>

<div style={{width: '100%',  alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}} >

<Text> Your Courses</Text>
 <ul style ={{listStyleType: 'none', padding: 0, width: '100%'}}>
    {courses.map(function(item){
     
         return (
          <div key={item.StartYear}  style={{ display: 'flex', width: '100%', justifyContent: 'center', flexDirection:'row', alignItems: 'center'}}>

  {item.CourseName.includes(searchQuery)?       
          <li  onClick={() => firebase.database()
    .ref('/User/' + user.uid )
    .update({
      
     
      Faculty: item.Name,
            Course: item.CourseName,
            EndYear: item.currentEndYear,
            StartYear: item.StartYear,
            MatricNo: '',
            Complete: '',
    })}>
    <div style={{width: '100%', backgroundColor: 'lightgrey', marginTop: '3%', padding: '3%',   borderRadius: 10, justifyContent: 'flex-start', flexDirection: 'column'}} >
    <h5><b>{item.CourseName}</b></h5>
<p>{item.Faculty + '-> from ' + item.StartYear + ' to ' + item.currentEndYear}</p>
</div>
</li>
    : null}

                   
          </div>
    )
    })}
</ul>
<div>

 <Button 
    onClick={() =>
    firebase.database()
       .ref('/User/' + `${user.uid}` + '/Faculty/'  )
        .remove()
    }>reset</Button>


<div style={{backgroundColor: 'grey', borderRadius: 10,padding: '3%', flexDirection: 'column', justifyContent: 'space-around'}}>

<div>


  <TextField
      label="Faculty Name"
      value={universityFaculty}
      onChange={handleFacultyChange}
       autoFocus={true}
      
    />
<Text> as a secondary school, you can keep the facultytext field blank </Text>

</div>

<TextField

      id="out-lined-number"
          label="Course Name"
         placeholder='course/ Department name'
          value={universityCourse}
          onChange={handleCourseChange}
         required
        
       autoFocus={true}
          error={false}
      
        />

<div style={{flexDirection: 'row'}} >
      
<TextField
      label="Start year"
      value={universityStartYear}
      onChange={handleStartYearChange}
      keyboardtype='number-pad'
       autoFocus={true}
       type='number'
       variant='outlined'

     
    />

    <TextField
      label="Likely End year"
      value={universityEndYear}
      onChange={handleEndYearChange}
      keyboardtype='number-pad'
       autoFocus={true}
       type='number'
       variant='outlined'
     
    />
    </div>

</div>

<Button

disabled={disabled} 
    onClick={() =>
    firebase.database()
       .ref('/User/' + `${user.uid}` + '/Faculty/' + universityCourse )
        .update({
                      
           CourseName: universityCourse,
           Faculty: universityFaculty,
           StartYear: universityStartYear,
           currentEndYear: universityEndYear

            
        })
    }>submit</Button>


    </div>

    { !school ?

      <div><FormControl component="fieldset">
      <FormLabel component="legend">Type of Instituition</FormLabel>
      <RadioGroup aria-label="gender" name="gender1" value={schoolChoice} onChange={handleChoiceChange}>
        <FormControlLabel value="University" control={<Radio />} label="University" />
        <FormControlLabel value="P" control={<Radio />} label="Institute of Technology" />
        <FormControlLabel value="C" control={<Radio />} label="College" />
        <FormControlLabel value="S"  control={<Radio />} label="Secondary School" />
      </RadioGroup>
    </FormControl>

    <Button

disabled={!schoolChoice ? true : false} 
    onClick={() =>
    firebase.database()
       .ref('/User/' + `${user.uid}` )
        .update({
                      
           School: schoolChoice

            
        })
    }>submit</Button>

</div>
   : <div><Button 
    onClick={handleClick}>Finish</Button>
    <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography><Text>Please ensure that the information you filled in is correct</Text>
<Button 
    onClick={() =>
    firebase.database()
        .ref('/User/' + user.uid )
        .update({
                      
           
            Complete: true,
            
        })
    }>Start Chatting</Button>
        </Typography>
      </Popover>
      </div>}

</div>
</div>

  )
}

function SchoolLocation () {

  const Countries = [ 
{"name": "Afghanistan", "code": "AF"}, 
{"name": "land Islands", "code": "AX"}, 
{"name": "Albania", "code": "AL"}, 
{"name": "Algeria", "code": "DZ"}, 
{"name": "American Samoa", "code": "AS"}, 
{"name": "AndorrA", "code": "AD"}, 
{"name": "Angola", "code": "AO"}, 
{"name": "Anguilla", "code": "AI"}, 
{"name": "Antarctica", "code": "AQ"}, 
{"name": "Antigua and Barbuda", "code": "AG"}, 
{"name": "Argentina", "code": "AR"}, 
{"name": "Armenia", "code": "AM"}, 
{"name": "Aruba", "code": "AW"}, 
{"name": "Australia", "code": "AU"}, 
{"name": "Austria", "code": "AT"}, 
{"name": "Azerbaijan", "code": "AZ"}, 
{"name": "Bahamas", "code": "BS"}, 
{"name": "Bahrain", "code": "BH"}, 
{"name": "Bangladesh", "code": "BD"}, 
{"name": "Barbados", "code": "BB"}, 
{"name": "Belarus", "code": "BY"}, 
{"name": "Belgium", "code": "BE"}, 
{"name": "Belize", "code": "BZ"}, 
{"name": "Benin", "code": "BJ"}, 
{"name": "Bermuda", "code": "BM"}, 
{"name": "Bhutan", "code": "BT"}, 
{"name": "Bolivia", "code": "BO"}, 
{"name": "Bosnia and Herzegovina", "code": "BA"}, 
{"name": "Botswana", "code": "BW"}, 
{"name": "Bouvet Island", "code": "BV"}, 
{"name": "Brazil", "code": "BR"}, 
{"name": "British Indian Ocean Territory", "code": "IO"}, 
{"name": "Brunei Darussalam", "code": "BN"}, 
{"name": "Bulgaria", "code": "BG"}, 
{"name": "Burkina Faso", "code": "BF"}, 
{"name": "Burundi", "code": "BI"}, 
{"name": "Cambodia", "code": "KH"}, 
{"name": "Cameroon", "code": "CM"}, 
{"name": "Canada", "code": "CA"}, 
{"name": "Cape Verde", "code": "CV"}, 
{"name": "Cayman Islands", "code": "KY"}, 
{"name": "Central African Republic", "code": "CF"}, 
{"name": "Chad", "code": "TD"}, 
{"name": "Chile", "code": "CL"}, 
{"name": "China", "code": "CN"}, 
{"name": "Christmas Island", "code": "CX"}, 
{"name": "Cocos (Keeling) Islands", "code": "CC"}, 
{"name": "Colombia", "code": "CO"}, 
{"name": "Comoros", "code": "KM"}, 
{"name": "Congo", "code": "CG"}, 
{"name": "Congo, The Democratic Republic of the", "code": "CD"}, 
{"name": "Cook Islands", "code": "CK"}, 
{"name": "Costa Rica", "code": "CR"}, 
{"name": "Cote D'Ivoire", "code": "CI"}, 
{"name": "Croatia", "code": "HR"}, 
{"name": "Cuba", "code": "CU"}, 
{"name": "Cyprus", "code": "CY"}, 
{"name": "Czech Republic", "code": "CZ"}, 
{"name": "Denmark", "code": "DK"}, 
{"name": "Djibouti", "code": "DJ"}, 
{"name": "Dominica", "code": "DM"}, 
{"name": "Dominican Republic", "code": "DO"}, 
{"name": "Ecuador", "code": "EC"}, 
{"name": "Egypt", "code": "EG"}, 
{"name": "El Salvador", "code": "SV"}, 
{"name": "Equatorial Guinea", "code": "GQ"}, 
{"name": "Eritrea", "code": "ER"}, 
{"name": "Estonia", "code": "EE"}, 
{"name": "Ethiopia", "code": "ET"}, 
{"name": "Falkland Islands (Malvinas)", "code": "FK"}, 
{"name": "Faroe Islands", "code": "FO"}, 
{"name": "Fiji", "code": "FJ"}, 
{"name": "Finland", "code": "FI"}, 
{"name": "France", "code": "FR"}, 
{"name": "French Guiana", "code": "GF"}, 
{"name": "French Polynesia", "code": "PF"}, 
{"name": "French Southern Territories", "code": "TF"}, 
{"name": "Gabon", "code": "GA"}, 
{"name": "Gambia", "code": "GM"}, 
{"name": "Georgia", "code": "GE"}, 
{"name": "Germany", "code": "DE"}, 
{"name": "Ghana", "code": "GH"}, 
{"name": "Gibraltar", "code": "GI"}, 
{"name": "Greece", "code": "GR"}, 
{"name": "Greenland", "code": "GL"}, 
{"name": "Grenada", "code": "GD"}, 
{"name": "Guadeloupe", "code": "GP"}, 
{"name": "Guam", "code": "GU"}, 
{"name": "Guatemala", "code": "GT"}, 
{"name": "Guernsey", "code": "GG"}, 
{"name": "Guinea", "code": "GN"}, 
{"name": "Guinea-Bissau", "code": "GW"}, 
{"name": "Guyana", "code": "GY"}, 
{"name": "Haiti", "code": "HT"}, 
{"name": "Heard Island and Mcdonald Islands", "code": "HM"}, 
{"name": "Holy See (Vatican City State)", "code": "VA"}, 
{"name": "Honduras", "code": "HN"}, 
{"name": "Hong Kong", "code": "HK"}, 
{"name": "Hungary", "code": "HU"}, 
{"name": "Iceland", "code": "IS"}, 
{"name": "India", "code": "IN"}, 
{"name": "Indonesia", "code": "ID"}, 
{"name": "Iran, Islamic Republic Of", "code": "IR"}, 
{"name": "Iraq", "code": "IQ"}, 
{"name": "Ireland", "code": "IE"}, 
{"name": "Isle of Man", "code": "IM"}, 
{"name": "Israel", "code": "IL"}, 
{"name": "Italy", "code": "IT"}, 
{"name": "Jamaica", "code": "JM"}, 
{"name": "Japan", "code": "JP"}, 
{"name": "Jersey", "code": "JE"}, 
{"name": "Jordan", "code": "JO"}, 
{"name": "Kazakhstan", "code": "KZ"}, 
{"name": "Kenya", "code": "KE"}, 
{"name": "Kiribati", "code": "KI"}, 
{"name": "Korea, Democratic People'S Republic of", "code": "KP"}, 
{"name": "Korea, Republic of", "code": "KR"}, 
{"name": "Kuwait", "code": "KW"}, 
{"name": "Kyrgyzstan", "code": "KG"}, 
{"name": "Lao People'S Democratic Republic", "code": "LA"}, 
{"name": "Latvia", "code": "LV"}, 
{"name": "Lebanon", "code": "LB"}, 
{"name": "Lesotho", "code": "LS"}, 
{"name": "Liberia", "code": "LR"}, 
{"name": "Libyan Arab Jamahiriya", "code": "LY"}, 
{"name": "Liechtenstein", "code": "LI"}, 
{"name": "Lithuania", "code": "LT"}, 
{"name": "Luxembourg", "code": "LU"}, 
{"name": "Macao", "code": "MO"}, 
{"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"}, 
{"name": "Madagascar", "code": "MG"}, 
{"name": "Malawi", "code": "MW"}, 
{"name": "Malaysia", "code": "MY"}, 
{"name": "Maldives", "code": "MV"}, 
{"name": "Mali", "code": "ML"}, 
{"name": "Malta", "code": "MT"}, 
{"name": "Marshall Islands", "code": "MH"}, 
{"name": "Martinique", "code": "MQ"}, 
{"name": "Mauritania", "code": "MR"}, 
{"name": "Mauritius", "code": "MU"}, 
{"name": "Mayotte", "code": "YT"}, 
{"name": "Mexico", "code": "MX"}, 
{"name": "Micronesia, Federated States of", "code": "FM"}, 
{"name": "Moldova, Republic of", "code": "MD"}, 
{"name": "Monaco", "code": "MC"}, 
{"name": "Mongolia", "code": "MN"}, 
{"name": "Montenegro", "code": "ME"},
{"name": "Montserrat", "code": "MS"},
{"name": "Morocco", "code": "MA"}, 
{"name": "Mozambique", "code": "MZ"}, 
{"name": "Myanmar", "code": "MM"}, 
{"name": "Namibia", "code": "NA"}, 
{"name": "Nauru", "code": "NR"}, 
{"name": "Nepal", "code": "NP"}, 
{"name": "Netherlands", "code": "NL"}, 
{"name": "Netherlands Antilles", "code": "AN"}, 
{"name": "New Caledonia", "code": "NC"}, 
{"name": "New Zealand", "code": "NZ"}, 
{"name": "Nicaragua", "code": "NI"}, 
{"name": "Niger", "code": "NE"}, 
{"name": "Nigeria", "code": "NG"}, 
{"name": "Niue", "code": "NU"}, 
{"name": "Norfolk Island", "code": "NF"}, 
{"name": "Northern Mariana Islands", "code": "MP"}, 
{"name": "Norway", "code": "NO"}, 
{"name": "Oman", "code": "OM"}, 
{"name": "Pakistan", "code": "PK"}, 
{"name": "Palau", "code": "PW"}, 
{"name": "Palestinian Territory, Occupied", "code": "PS"}, 
{"name": "Panama", "code": "PA"}, 
{"name": "Papua New Guinea", "code": "PG"}, 
{"name": "Paraguay", "code": "PY"}, 
{"name": "Peru", "code": "PE"}, 
{"name": "Philippines", "code": "PH"}, 
{"name": "Pitcairn", "code": "PN"}, 
{"name": "Poland", "code": "PL"}, 
{"name": "Portugal", "code": "PT"}, 
{"name": "Puerto Rico", "code": "PR"}, 
{"name": "Qatar", "code": "QA"}, 
{"name": "Reunion", "code": "RE"}, 
{"name": "Romania", "code": "RO"}, 
{"name": "Russian Federation", "code": "RU"}, 
{"name": "RWANDA", "code": "RW"}, 
{"name": "Saint Helena", "code": "SH"}, 
{"name": "Saint Kitts and Nevis", "code": "KN"}, 
{"name": "Saint Lucia", "code": "LC"}, 
{"name": "Saint Pierre and Miquelon", "code": "PM"}, 
{"name": "Saint Vincent and the Grenadines", "code": "VC"}, 
{"name": "Samoa", "code": "WS"}, 
{"name": "San Marino", "code": "SM"}, 
{"name": "Sao Tome and Principe", "code": "ST"}, 
{"name": "Saudi Arabia", "code": "SA"}, 
{"name": "Senegal", "code": "SN"}, 
{"name": "Serbia", "code": "RS"}, 
{"name": "Seychelles", "code": "SC"}, 
{"name": "Sierra Leone", "code": "SL"}, 
{"name": "Singapore", "code": "SG"}, 
{"name": "Slovakia", "code": "SK"}, 
{"name": "Slovenia", "code": "SI"}, 
{"name": "Solomon Islands", "code": "SB"}, 
{"name": "Somalia", "code": "SO"}, 
{"name": "South Africa", "code": "ZA"}, 
{"name": "South Georgia and the South Sandwich Islands", "code": "GS"}, 
{"name": "Spain", "code": "ES"}, 
{"name": "Sri Lanka", "code": "LK"}, 
{"name": "Sudan", "code": "SD"}, 
{"name": "Suriname", "code": "SR"}, 
{"name": "Svalbard and Jan Mayen", "code": "SJ"}, 
{"name": "Swaziland", "code": "SZ"}, 
{"name": "Sweden", "code": "SE"}, 
{"name": "Switzerland", "code": "CH"}, 
{"name": "Syrian Arab Republic", "code": "SY"}, 
{"name": "Taiwan, Province of China", "code": "TW"}, 
{"name": "Tajikistan", "code": "TJ"}, 
{"name": "Tanzania, United Republic of", "code": "TZ"}, 
{"name": "Thailand", "code": "TH"}, 
{"name": "Timor-Leste", "code": "TL"}, 
{"name": "Togo", "code": "TG"}, 
{"name": "Tokelau", "code": "TK"}, 
{"name": "Tonga", "code": "TO"}, 
{"name": "Trinidad and Tobago", "code": "TT"}, 
{"name": "Tunisia", "code": "TN"}, 
{"name": "Turkey", "code": "TR"}, 
{"name": "Turkmenistan", "code": "TM"}, 
{"name": "Turks and Caicos Islands", "code": "TC"}, 
{"name": "Tuvalu", "code": "TV"}, 
{"name": "Uganda", "code": "UG"}, 
{"name": "Ukraine", "code": "UA"}, 
{"name": "United Arab Emirates", "code": "AE"}, 
{"name": "United Kingdom", "code": "GB"}, 
{"name": "United States", "code": "US"}, 
{"name": "United States Minor Outlying Islands", "code": "UM"}, 
{"name": "Uruguay", "code": "UY"}, 
{"name": "Uzbekistan", "code": "UZ"}, 
{"name": "Vanuatu", "code": "VU"}, 
{"name": "Venezuela", "code": "VE"}, 
{"name": "Viet Nam", "code": "VN"}, 
{"name": "Virgin Islands, British", "code": "VG"}, 
{"name": "Virgin Islands, U.S.", "code": "VI"}, 
{"name": "Wallis and Futuna", "code": "WF"}, 
{"name": "Western Sahara", "code": "EH"}, 
{"name": "Yemen", "code": "YE"}, 
{"name": "Zambia", "code": "ZM"}, 
{"name": "Zimbabwe", "code": "ZW"} 
]

const [schoolLocation, setSchoolLocation] = useState('');
const [schoolState, setSchoolState] = useState('');

      const handleLocationChange = (event) => {
    setSchoolLocation(event.target.value);
  };

   const handleStateChange = (event) => {
    setSchoolState(event.target.value);
  };

  return(

  <div>
<Text>It is possible for your school to share a name with a { userProfile == 'school' ? 'school' : 'Business' } in another part of the world, so to narrow in the identification process, you will have to choose which <b>country</b> your { userProfile == 'school' ? 'school' : 'Business' } is located in, and which <b>state</b> it is located within the country’s jurisdiction</Text>

 <TextField
          id="standard-select-country"
          select
          label="Select"
          value={schoolLocation}
          onChange={handleLocationChange}
          helperText="Please select your country"
        >
          {Countries.map((option) => (
            <MenuItem key={option.code} value={option.name}>
             {option.name}
            </MenuItem>
          ))}
        </TextField>

<TextField

      id="out-lined-state"
          label="Address"
         placeholder={ userProfile == 'type your school address ' ? 'school' : 'type your Business address' }
          value={schoolState}
          onChange={handleStateChange}
         required
         fullWidth= {true}
       autoFocus={true}
          error={false}
      
        />



<Text>If you run a virtual or online { userProfile == 'school' ? 'school' : 'Business' }, just type <b>online</b></Text>

<p> Your Business can be found  {schoolState == 'online' ? 'online': 'at ' + schoolState}, {schoolLocation}?</p>
<Button 
disabled={!schoolState ? true : false}
    onClick={() =>
    firebase.database()
        .ref('/User/' + user.uid )
        .update({
                      
           
            Country: schoolLocation,
            State: schoolState
            
        })
    }>Save </Button>
  </div>
  )
}

const allInputs = {imgUrl: ''};
    const [imageAsFile, setImageAsFile] = useState('');
    const [imageAsUrl, setImageAsUrl] = useState(allInputs);
    const [media, setMedia] = useState(null);
  const time = new Date().getTime();

 const handleImageAsFile = (e) => {
      const image = e.target.files[0]
      setImageAsFile(imageFile => (image));
    

  }


const [uploaded, setUploaded] = useState(false);
const [downloadURL, setDownloadURL] = useState('');



 
 async function sendImage () {

    
 await firebase.storage().ref('/User/' + `/${user.uid}/` +  '/photoURL/'  ).put(imageAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
  
});

await firebase.storage().ref('/User/' + `/${user.uid}/` + '/photoURL/' ).getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
    const url = '';
   setDownloadURL(downloadURL);

  });

  
 




  
}




  return(
<div>
{ userProfile == 'Student' ? <StudentAdditional/>
: userProfile == 'Business' ? <BusinessAdditional/> : <SchoolAdditional/>
}

</div>
)
}






  

 



function Accordion () {
  return (
    <div className='communityScreen' style={{flex: 1, display: {displays}, height: '100vh', width: '15%', padding: '2%', position: 'sticky', right: '0%'}}> 

    

</div>

  )
}

function Accordions () {
  return (
    <div className='communityScreen' style={{ flex: 1, display: {displays}, backgroundColor: '#E7F2F1', height: '100vh', width: '16%', padding: '2%', position: 'fixed', right: '0%'}}> 
<h3> online users</h3>

 <ul>
    {online.map(function(item){
      const templateString = "{uids}";
      const uids = item.uid;

const template = templateString.replace('{uids}', uids);
         return (<div key={item.uid}  >
                     <Link to={template}>
                         <li style={{flexDirection: 'column'}}><Text><b>{item.displayName}</b></Text><Text>{item.email}</Text></li>
                     </Link>
                  </div>)
       })}
</ul>


</div>
  )
}
const {displays, setDisplays} = useState('block');


 function Accordionss () {
  if (window.screen.availHeight > window.screen.availWidth) {

    return null}else {
      return <Accordions/>
    }
 }

 function Accordionsss () {
  if (window.screen.availHeight > window.screen.availWidth) {

    return null}else {
      return <Accordion/>
    }
 }

 function Nothing () {
  const [messages, setMessages] = useState([]);
  const [ids, setIds] = useState([]);
  const [id, setId] = useState([]);
  

  useEffect(() => {

    const onChildAdd = firebase.database().ref('/User/' + `/${user.uid}/` + '/LatestMessages/'  ).orderByChild('createdAt').on('value', function(snapshot) {
const messages = [];
const ids = [];

snapshot.forEach(function(userSnapshot) {
const id = userSnapshot.key;
const message = userSnapshot.val();

ids.push(id);
messages.push(message);


});
setMessages(messages);
setIds(ids);
 

});







 return () =>
   firebase.database().ref('/User/' + `/${user.uid}/` + '/LatestMessages/'  )
        .off('value', onChildAdd);


}, []);




console.log(messages);
  
  return (
  <div>

{!messages ? null : <p>swipe to see more</p> }<ul style={{listStyleType: 'none', display: 'flex', flexDirection:'row'}}>
    {messages.map(function(item){
      const templateString = "{uids}";
      const uids = item.uid;

const template = templateString.replace('{uids}', uids);
         return (<Link to={template} key={item.createdAt} style={{width: '100%'}} >
          <div style={{width: '100%', padding: '1%', justifyContent: 'flex-start', flexDirection:'row', alignItems: 'center', backgroundColor: 'lightgrey', borderRadius: 10, marginTop: '3%'}} ><Avatar src={item.avatar}/> <div style={{ padding: '2%', width: '100%', flexDirection: 'column'}}><Text><b>{item.displayName}</b></Text> <Text>{item.text === ''  ? 'media content' : item.text }</Text></div>

</div>
          </Link>
          )
       })}
</ul>
  </div>)
}

 function Feds (props) {
    const item = useParams();
      const [refreshing, setRefreshing] = React.useState(false);
      const [modalVisible, setModalVisible] = useState(false);
      const [ rate, setRate ] = useState('');
      const [ loading, setLoading ] = useState(true);
      const [ texts, setTexts ] = useState('');
      const [message, setMessage] =useState('');
      
      const [newMessage, setNewMessage] =useState([]);
      const [newMessages, setNewMessages] =useState([]);
      const [count, setCount] = useState(0);
      const [profile, setProfile] = useState(false);

       const [schoolUsers, setSchoolUsers] = useState([]);
  const [id, setId] = useState([]);
  const [ids, setIds] = useState([]);
  const [idss, setIdss] = useState([]);

    const [value, setValue] = useState(0);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const [personal, setPersonal] = useState([]);
  const [other, setOther] = useState([]);
  
  const classes = useStyles(); 

    const [title, setTitle] = useState('Your business name here');
const [propsName, setPropsName] = useState('');
const [propsphotoURL, setPropsphotoURL] = useState('');


 function handleMessageChange(event) {
   setText(event.target.value);
    
  }

  useEffect(() => {
firebase.database()
.ref('/User/'+ `/${props.uid}/` )
.once('value')
.then(snapshot => {
  setPropsName(snapshot.val().displayName);
  setPropsphotoURL(snapshot.val().photoURL);
  console.log('User data: ', propsName);

});

  });

  
 useEffect(() => {

    const onChildAdd = firebase.database().ref('/User/' + `/${user.uid}/` + '/Messages/' + `/${props.uid}/` ).orderByChild('createdAt').on('value', function(snapshot) {
const messages = [];
const ids = [];

snapshot.forEach(function(userSnapshot) {
const id = userSnapshot.key;
const message = userSnapshot.val();

ids.push(id);
setId(id);
messages.push(message);


});
setMessages(messages);
setIds(ids);
 

});







 return () =>
    firebase.database().ref('/User/' + `/${user.uid}/` + '/Messages/' + `/${props.uid}/` )
        .off('value', onChildAdd);


});





 
const allInputs = {imgUrl: ''};
    const [imageAsFile, setImageAsFile] = useState('');
    const [imageAsUrl, setImageAsUrl] = useState(allInputs);
    const [media, setMedia] = useState(null);
    const [fileType, setFileType] = useState('');

const [uploadArray, setUploadArray] = useState([]);


 const handleImageAsFile = (e) => {
      const image = e.target.files[0]
      setImageAsFile(imageFile => (image));
      setMedia(image);
     setFileType(image.type);
     console.log(fileType);

  }


const [uploaded, setUploaded] = useState(false);
const [downloadURL, setDownloadURL] = useState('');


const time = new Date().getTime();


 async function sendMessage () {
  
    await firebase.storage().ref('/User/' + `/${user.uid}/` + '/Messages/' + `/${props.uid}/` + `/${time}/` ).put(imageAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
  
});

  await firebase.storage().ref('/User/' + `/${user.uid}/` + '/Messages/' + `/${props.uid}/` + `/${time}/` ).getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
    const url = '';

    const pushingToUserDatabse = firebase.database().ref('/User/' + `/${user.uid}/` + '/Messages/' + `/${props.uid}/` + `/${time}/` );
     pushingToUserDatabse.set({
    displayName: user.displayName,
    text: text,
    createdAt: time,
    Image: downloadURL,
     MediaType: fileType,
     uid: user.uid,

    // ...
  });


   const pushingToOtherDatabase = firebase.database().ref('/User/' + `/${props.uid}/` + '/Messages/' + `/${user.uid}/` + `/${time}/` );
     pushingToOtherDatabase.set({
    displayName: displayName,
    text: text,
    createdAt: time,
    Image: downloadURL,
     MediaType: fileType,
     uid: user.uid,

    
    // ...
  });


const pushingToUserDatabaseLatest = firebase.database().ref('/User/' + `/${user.uid}/` + '/LatestMessages/' + `/${props.uid}/` );
pushingToUserDatabaseLatest.set({
displayName: propsName,
text: text,
avatar: propsphotoURL,
createdAt: time,
 MediaType: fileType,
 uid: props.uid

// ...
});

const pushingToOtherDatabaseLatest = firebase.database().ref('/User/' + `/${props.uid}/` + '/LatestMessages/' + `/${user.uid}/` );
pushingToOtherDatabaseLatest.set({
displayName: displayName,
text: text,
avatar: user.photoURL,
createdAt: time,
 MediaType: fileType,
 uid: user.uid,


// ...
});
   

setText('');

  });


   


       

  

}










  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const openid = open ? 'simple-popover' : undefined;


  return (
 <div style={{width: '100%', display: 'flex', flexDirection: 'column', padding: '3%', justifyContent: 'center'}} >
 <p>{propsName}</p> 

     <ul style={{listStyleType: 'none'}}>
    {messages.map(function(item){
             return (<li key={item.createdAt} style={{display: 'flex', flexDirection: 'column', position: 'relative',  backgroundColor: item.uid != user.uid ? 'green': 'grey', float: item.uid != user.uid ? 'left' : 'right', maxWidth: '80%', minWidth: 0, borderRadius: 10, marginTop: 2 }}><div style={{overflow: 'auto', objectFit: 'cover', fontSize: 'calc(4px + 2vmin)', borderRadius: 10 ,  }}> 
                     { item.MediaType.includes('image') ? <img src={item.Image} loading='lazy'  width='inherit' alt={item.Description} /> : item.MediaType.includes('video')? <video preload='metadata' src={item.Image} loop={true} width='450vh'  controls controlsList='nodownload nofullscreen noremoteplayback'  /> : item.MediaType.includes('application') ? <iframe
    src={item.Image}
    frameBorder="0"
    scrolling="auto"
    width="inherit"
></iframe> : null}
</div>
  <p style={{   padding: '0.1%', }}> {item.text + item.uid}</p>
                </li>)
      }
       )}

       </ul> 

        



<div style={{width: '50vh'}} >
{fileType.includes('image') ? <img src={media? URL.createObjectURL(media) : null} alt={media? media.name : null}/> : fileType.includes('video') ? <video preload='metadata' src={media? URL.createObjectURL(media) : null} loop={true} width='450vh'  controls controlsList='nodownload nofullscreen noremoteplayback'  /> : null }      
<p>{fileType}</p>

</div>
<form>
       <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', objectFit: 'contain'}} >

<label htmlFor="filePicker" >
<AddAPhotoIcon onClick={handleClick}/>
</label>
<input id="filePicker" style={{visibility:"hidden", width: '1vh'}} onChange={handleImageAsFile} type={"file"} />

 
    
  <TextField
          id="outlined-text"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          placeholder='type your message here'
          required
          value = {text}
          fullWidth
          autoFocus={true}
          onChange= {handleMessageChange}
        />
       


       <IconButton aria-label="save"  onClick={sendMessage}
>
  <SendIcon />
</IconButton>
</div>


</form>

</div>
 
)  }


 function FriendMessagesScreen () {
      const [loading, setLoading] = useState(true);
      const [threads, setThreads] = useState([]);
      //const {threads} = useContext(userMessages);

    
            
            if (loading) {
              setLoading(false);
            }
           
            


      if (loading) {
        return <p>please wait a bit</p>; // or a spinner
      }
      
     
      return (
        <div style={{flex: 1}}>
          
          <Router>
                  <Feds exact path=":uid" />
                   <Nothing exact path="/" />
                   

                  </Router>  
          
                  
                  <div style={{ width: 'auto', height: 'auto',  justifyContent: 'flex-end', alignSelf: 'center', borderRadius: 30, backgroundColor: 'seagreen', }} > 

       <ChatIcon />  

        

         </div>
                
             
          
          </div>
       
                );


      
     }

 

function SideNav () {
  return (
    <div className='communityScreen' style={{flex: 1, display: {displays}, height: '100%', width: '25%', padding: '4%', position: 'sticky', }}> 

    

</div>

  )
}


function SideNavs () {
  return (
    <div className='communityScreen' style={{ flex: 1, display: {displays}, backgroundColor: '#E7F2F1', height: '100%', width: '10%', padding: '2.5%', position: 'fixed', left: '0%', }}> 

<div class='Menu'>
   
             <div className= 'MenuLink'><NavigateNextIcon style={{transform: 'scaleX(-1)'}}/><Link to="Chats" >Chats</Link></div>
         <div className= 'MenuLink'><NavigateNextIcon style={{transform: 'scaleX(-1)'}}/><Link to="" >Community</Link></div>
        
      </div>   
          
      
</div>
  )
}


function MenuButton () {



  const [left, setLeft] = useState('none');
const [right, setRight] = useState('flex');
  function menuNavigation () {

    setLeft('flex');
    setRight('none');
  }


function menuNavigationReverse () {

    setLeft('none');
    setRight('flex');
  }
  return (
    <div className='communityScreen' style={{ flex: 1, display: 'flex', flexDirection: 'row', height: 'auto' , position: 'fixed', left: '0%', top: '0%', zIndex: '100',}}> 

  <div className='communityScreen' style={{ flex: 1, display: left, backgroundColor: '#E7F2F1',  flexDirection: 'column', justifyContent: 'flex-start', height: '100%', width: '50%', position: 'fixed', }}> 
<div style={{  zIndex: '100', display: 'flex', flexDirection: 'row', backgroundColor: '#E19292', height: 'auto', width: '100%', padding: '1.5%', justifyContent: 'space-between', alignContent: 'center', alignSelf: 'center', alignItems: 'center'}} onClick={menuNavigationReverse}>
   <NavigateNextIcon style={{transform: 'scaleX(-1)'}}/>
<h3> Menu </h3>
      </div>
  <div class='Menu'>
   
             <p className= 'MenuLink'><NavigateNextIcon style={{transform: 'scaleX(-1)'}}/><Link to="" >Chats</Link></p>
         <p className= 'MenuLink'><NavigateNextIcon style={{transform: 'scaleX(-1)'}}/><Link to="Community" >Community</Link></p>
        
      </div>   

  
          
      
</div>
  <div style={{  display: right, zIndex: '100', backgroundColor: 'seagreen', height: '100%', width: '100%', top: '20%', padding: '24.5%',}} onClick={menuNavigation}>
   <div style={{padding: '12.5%'}}><NavigateNextIcon/></div>

      </div>   

          
      
</div>
  )
}



 function SideNavss () {
  if (window.screen.availHeight > window.screen.availWidth) {

    return <MenuButton/>
  }else {
      return <SideNavs/>
    }
 }

 function SideNavsss() {
  if (window.screen.availHeight > window.screen.availWidth) {

    return null}else {
      return <SideNav/>
    }
 }


function CommunityScreen () {
   

      return (
        <div style={{display: {display}}}>
          
          <Router>
          <CommunityList exact path='/' />
          <ChatRoomList exact path=":uid" >
             <OutsideChatRoom exact path='/' />
            <InsideChatRoom exact path=":name" />
          </ChatRoomList>
            </Router>
        
          
                  

                           

                
          
          </div>

       
                )
      
     }


function ChatRoomList () {

  return (

   <Router>
   <OutsideChatRoom exact path='/' />
    <InsideChatRoom exact path=":name" />
</Router>
   )
}


function CommunityList () {


         const [searchCommunities, setSearchCommunities] = useState('');

        const onChangeCommunitySearch = (event) => {
    setSearchCommunities(event.target.value);
  };


  return (
    <div>
    <p> here is where the community list is </p>

    {userProfile != 'Student' ?<Link to={user.uid} ><div style={{width: '100%', padding: '5%', justifyContent: 'flex-start', flexDirection:'row', alignItems: 'center', backgroundColor: 'tomato', borderRadius: 10, marginTop: '3%'}} ><Avatar src={displayPicture}/> <div style={{ padding: '2%', width: '100%', flexDirection: 'column'}}><Text><b>{displayName}</b></Text> <Text>div your community</Text></div>

</div></Link> : null
  }

     <TextField

      id="out-lined-number"
          label="Search"
         placeholder='search by abbr name'
          value={searchCommunities}
          onChange={onChangeCommunitySearch}
         required
         fullWidth= {true}
       autoFocus={true}
          error={false}
      
        />
         

<ul style ={{listStyleType: 'none', padding: 0}} >
    {online.map(function(item){
     
         return (
          <li   key={item.createdAt} style={{flex: 1, display: 'flex', width: '100%', justifyContent: 'center', flexDirection:'row', alignItems: 'center'}}>

  {item.User == 'School' ? item.email.includes(searchCommunities)?
          
  <Link  to={item.uid}>       

<div style={{width: '100%', padding: '5%', justifyContent: 'flex-start', flexDirection:'row', alignItems: 'center', backgroundColor: 'lightgrey', borderRadius: 10, marginTop: '3%'}} ><Avatar src={item.photoURL}/> <div style={{ padding: '2%', width: '100%', flexDirection: 'column'}}><Text><b>{item.displayName}</b></Text> <Text>{item.School} ---- {item.State}, {item.Country}</Text></div></div></Link>
   
          : null
: null}
                   
          </li>
    )
    })}
</ul>
</div>
    )
}



function InsideChatRoom (props) {
  const receivedName = props.name;

useEffect(() => {
  setInsideChatRoomProps(props.name);
})

const allInputs = {imgUrl: ''};
    const [imageAsFile, setImageAsFile] = useState('');
    const [imageAsUrl, setImageAsUrl] = useState(allInputs);
    const [media, setMedia] = useState(null);
    const [fileType, setFileType] = useState('');

const [uploadArray, setUploadArray] = useState([]);


 function handleImageAsFile (e) {
      const image = e.target.files[0]
      setImageAsFile(imageFile => (image));
      setMedia(image);
     setFileType(image.type);

  }


 const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

const [buttonBoolean, setButtonBoolean] = useState(true);
  const [pageView, setPageView] = useState('true');
  const [importantMessage, setImportantMessage] = useState('')

async function sendImportantMessage () {

  await firebase.database()
    .ref('/User/' + `/${yearProps}/` + '/Year/' + `/${schoolYear}/` + `/${insideChatRoomProps}/` )
    .push({
      
     text: importantMessage,     
           
    })
setImportantMessage('');
console.log(insideChatRoomData);

}
const [scheduledClass, setScheduledClass] = useState('');
const [scheduledClassTitle, setScheduledClassTitle] = useState('');
const [startScheduledClass, setStartScheduledClass] =useState(true);
const [startClassNow, setStartClassNow] =useState(true);
const [addStudent, setAddStudent] = useState('');

  const [streams, setStreams] = useState('');
  const constraints = {
  video: true,
  audio: true,
};

var chunks = [];

const recordedBlobs = [];
var recordedChunks = [];


const videos = createRef(null);
const remotevideo = createRef(null);
  
const [loadingDescription, setLoadingDescription] = useState('');




 function recordLive () {

  navigator.mediaDevices.getDisplayMedia({ video: true}).then( async (localStream, remoteStream)  => {

      console.log(localStream);

  videos.current.srcObject = localStream;

  videos.current.onloadedmetadata = function(e) {
    videos.current.play();
  };

 

});
navigator.mediaDevices.getUserMedia({ video: true}).then( async (localStream, remoteStream)  => {

      console.log(localStream);

  remotevideo.current.srcObject = localStream;

  remotevideo.current.onloadedmetadata = function(e) {
    remotevideo.current.play();
  };

 

})
}

function reloadVideoStream () {
   setInterval(event => {
 
recordLive();

}, 9000);

}

function getStream(videoElem) {

  const stream = videos.current.srcObject;
  const tracks = stream.getTracks();

  tracks.forEach(function(track) {
    track.stop();
  });
console.log(tracks);
  videos.current.srcObject = null;
}

const addingStudents = online.filter( function(item) {
  item.displayName.includes(addStudent);
  console.log(item.displayName);
});



  return(
  <div  style={{width: '100%', backgroundColor: 'white', display: 'flex', height: window.screen.availHeight, flexDirection: 'column', justifyContent: 'flex-start'}} >
  <div style={{position: 'sticky', top: 0, zIndex: 100}} >
<div onClick={() => setPageView('truefalse') } style={{width: '100%',  position: 'sticky', top: 0, backgroundColor: 'grey', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', }} >
<b style={{padding: '1%'}} >{insideChatRoomProps}</b><i style={{padding : '1%'}}>name of school</i></div>


<div style={{width: '100%', backgroundColor: 'grey', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}} >
<div onClick={() => setPageView('true') } style={{width: '50%', backgroundColor: 'tomato', display: 'flex', flexDirection: 'row', justifyContent: 'center'}} ><p>Important</p></div>
<div  onClick={() => setPageView('false') } style={{width: '50%', backgroundColor: 'lightgreen', display: 'flex', flexDirection: 'row', justifyContent: 'center'}} ><p>Chats</p></div>
</div>
</div>
{ pageView === 'true' ? 

<div style={{width: '100%', backgroundColor: 'grey', height: window.screen.availHeight * 0.9}} >

{ buttonBoolean === true ? 

  <div>{!insideChatRoomData ? <p> get updates and classes started from here</p> 
    :
    <ul>
 {insideChatRoomData.map(function(item){
     
         return (
 <Button key={item.y}
        size={item.y == schoolYear ? "large" : "small"}
        color={item.y == schoolYear ? "secondary" : "primary"}
      >{item.text}</Button>
             
 )
    })}</ul>
  }</div>

  :
<div style={{width: '100%',  display: 'flex', justifyContent: 'center'}} >
<ButtonGroup
        orientation="vertical"
        color="primary"
        aria-label="vertical contained primary button group"
        variant="text"
        style={{justifyContent: 'center', marginTop: '5%', width: '80%',height: '100%'}}
      >
        <Button style={{ padding: '10%'}} startIcon={<DeleteIcon />} onClick={() => setStartScheduledClass(!startScheduledClass)} >Schedule a class</Button>
{startScheduledClass === true ? null :<div>
  <input id="filePicker" onChange={(e) => setScheduledClass(e.target.value) }  type="datetime-local" />
<TextField value={scheduledClassTitle} onChange={(e) => setScheduledClassTitle(e.target.value)} placeholder='Title of scheduled class' /> 
<input type='file' />
<Button  >Schedule</Button></div>}

        <Button  style={{ padding: '10%'}} startIcon={<DeleteIcon />} onClick={() => setStartClassNow(!startClassNow)} >Start a class now</Button>

{!startClassNow ? null :
<div style={{display:'flex', flexDirection: 'column' }} >
<div style={{display:'flex', flexDirection: 'row',justifyContent:'space-around' }} >
<video ref={videos}  autoPlay defaultmuted = 'true' width='50%'  ></video>
<video ref={remotevideo}  autoPlay defaultmuted = 'true' width='50%'  ></video></div>
   <Button onClick={recordLive}>Record</Button>
   <Button onClick={getStream}>stop</Button></div>}

        <Button  style={{ padding: '10%'}} startIcon={<DeleteIcon />}>Upload Materials</Button>
      </ButtonGroup>
</div>

}
{scheduledClass}
<div style={{display: 'flex', flexDirection: 'row', backgroundColor: 'lightgrey', width: window.screen.availHeight > window.screen.availWidth ? window.screen.availWidth: window.screen.availHeight , zIndex: 100, position: 'fixed', bottom: 0, left:  window.screen.availHeight > window.screen.availWidth ? 0: null}}>
<Button variant="contained" color="secondary" title='Start a session' onClick={() => setButtonBoolean(!buttonBoolean)} >Start a session</Button>
<TextField autoFocus id="filled-basic" fullWidth placeholder= {media ? 'add media description' : 'type your message'} variant="filled" value={importantMessage} onChange={(e) => setImportantMessage(e.target.value) }  />
<Button icon={<sendIcon/>} onClick={sendImportantMessage}  />
</div>
</div>

: pageView === 'false' ?

<div>

{ media ? <div>{ fileType.includes('image') ?<img width='100%' src={media? URL.createObjectURL(media) : null} alt={media? media.name : null}/>  : <video width='100%' autoPlay  src={media? URL.createObjectURL(media) : null} alt={media? media.name : null} />}</div>
: <p> chats screen for students {fileType}</p>}

<form className={classes.root} noValidate autoComplete="off" style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}} >
         <label className="btn btn-default">
        <input type="file"  onChange={handleImageAsFile} accept="image/png, image/gif, image/jpeg, video/mp4, video/3gp"
/>
      </label>

  <TextField autoFocus id="filled-basic" placeholder= {media ? 'add media description' : 'type your message'} variant="filled" fullWidth />
}
</form>
</div>


:
<div style={{display:'flex', flexDirection:'column'}} ><p>you should be able to add students from here</p>





<div style={{display:'flex', flexDirection: 'row', width:'100%' }}>
<Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
      >
        <Tab label="Edit Group info"   />
        <Tab label="Staffs"  />

        <Tab label="Students"  />
      </Tabs>

      
     <TabPanel value={value} index={0}><form className={classes.root} noValidate autoComplete="off" style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}} >
        <p>change the class display picture</p>
        <i>anyone,students or staffs you add here can change this inforation</i>

         <label className="btn btn-default">
        <input type="file"  onChange={handleImageAsFile} accept="image/png, image/gif, image/jpeg, video/mp4, video/3gp"
/>
      </label>

<p>Change the class decription</p>
<i>anyone,students or staffs you add here can change this inforation</i>
  <div style={{display: 'flex', flexDirection: 'row'}} > <TextField autoFocus id="filled-basic" placeholder= 'change the class description' value='no description yet' variant="filled" fullWidth />
  <Button>save</Button></div>
}
</form></TabPanel>


      <TabPanel value={value} index={1}>
<Button icon={<DeleteIcon/>}>add Staffs</Button>
<p>these staffs can schedule or start a class from the important tab</p>
      </TabPanel> 


      <TabPanel value={value} index={2}>
<Button icon={<FavoriteIcon/>} >add students</Button>
<p> these students will not be able to post in the information tab unless a class is started</p>
<TextField autoFocus id="filled-basic" placeholder= 'change the class description' value={addStudent} onChange={(e) => setAddStudent(e.target.value)} variant="filled" fullWidth />
      
{ !addStudent ? null : <ul style ={{listStyleType: 'none', padding: 0}} >
    {addingStudents.map(function(item){
     
         return (
          <li   key={item.createdAt} style={{flex: 1, display: 'flex', width: '100%', justifyContent: 'center', flexDirection:'row', alignItems: 'center'}}>

          

<div  onClick={() =>
    firebase.database()
        .ref('/User/' + item.uid )
        .update({
                      
           
            Complete: true,
            
        })
    } style={{width: '100%', padding: '5%', justifyContent: 'flex-start', display: 'flex', flexDirection:'row', alignItems: 'center', backgroundColor: 'lightgrey', borderRadius: 10, marginTop: '3%'}} ><Avatar src={item.photoURL}/> <div style={{ padding: '2%', width: '100%', flexDirection: 'column'}}><Text><b>{item.displayName}</b></Text> <Text>{item.School} ---- {item.State}, {item.Country}</Text></div></div>
   
          
                   
          </li>
    )
    })}
</ul>}
      </TabPanel>
      </div>

</div>

}


</div>
  )
}



function OutsideChatRoom (props){
  const classes = useStyles();
  const [display, setDisplay] = useState('flex');

        const [loading, setLoading] = useState(true);
              
       const [newCommunity, setNewCommunity] = useState(false);
    const [comminityList, setCommunityList] = useState([]);
    const [communityName, setCommunityName] = useState('');
    const [communityDescription, setCommunityDescription] = useState('');
    const [facultyTitle, setFacultyTitle] = useState('');
  const [yearList, setYearList] = useState([]);
  const [businessList, setBusinessList] =useState([]);
  
 
 const allInputs = {imgUrl: ''};
    const [imageAsFile, setImageAsFile] = useState('');
    const [imageAsUrl, setImageAsUrl] = useState(allInputs);
    const [media, setMedia] = useState(null);
    const [fileType, setFileType] = useState('');

const [uploadArray, setUploadArray] = useState([]);


 const handleImageAsFile = (e) => {
      const image = e.target.files[0]
      setImageAsFile(imageFile => (image));
      setMedia(image);
     setFileType(image.type);
     console.log(fileType);

  }

const [disabled, setDisabled] = useState(false);
const [loadingDescription, setLoadingDescription] = useState('');
const [currentTime, setCurrentTime] = useState('');
const currenTime = new Date().getTime();

   async function uploadStatus () {
    setNewCommunity(!newCommunity);

     setCurrentTime(currenTime);

     setLoadingDescription('loading of setMedia to database is ongoing, do not cancel');
     setDisabled(true);
      await firebase.storage().ref('/Business/Communities' + user.uid + `/${currenTime}/` ).put(imageAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
       setLoadingDescription('loading of image to database is ongoing, do not cancel');

  
});

      
 setLoadingDescription('now its time to upload the texts, should be done soon');
        await  firebase.storage().ref('/Business/Communities' + user.uid + `/${currenTime}/`).getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
   firebase.database().ref('/User/' + `/${user.uid}/` + '/Communities/' + `/${currenTime}/`).update({
    Title: communityName,
    Image: downloadURL,
    time: currenTime,
    displayName: displayName,
    Description: communityDescription,
   
    // ...
  });

     
  


  });
        }







const [universityYear, setUniversityYear] = useState('');




 const handleYearChange = (event) => {
    setUniversityYear(event.target.value);
  };

useEffect(() => {
          if (universityYear.length != 4) {
            setDisabled(true)
          }else if (universityYear == ''){
            setDisabled(true)
          }else {
            setDisabled(false)
          }
       
        }, [universityYear])

useEffect(() => {
    setYearProps(props.uid);

  }, [props.uid])
async function addYear() {

  await firebase.database()
    .ref('/User/' + props.uid + '/Year/' + `/${universityYear}/` )
    .update({
      
     y: universityYear     
           
    })
} 





   async function uploadStatus () {
    setNewCommunity(!newCommunity);

     setCurrentTime(currenTime);

     setLoadingDescription('loading of setMedia to database is ongoing, do not cancel');
     setDisabled(true);
      await firebase.storage().ref('/School/Communities' + props.uid + `/${currenTime}/` ).put(imageAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
       setLoadingDescription('loading of image to database is ongoing, do not cancel');

  
});

      
 setLoadingDescription('now its time to upload the texts, should be done soon');
        await  firebase.storage().ref('/School/Communities' + props.uid + `/${currenTime}/`).getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
   firebase.database().ref('/User/' + `/${props.uid}/` + '/Year/' + schoolYear + `/${communityName}/`).update({
    Name: communityName,
    Faculty: facultyTitle,
    Image: downloadURL,
    time: currenTime,
    schoool: displayName,
    Description: communityDescription,
   
    // ...
  });


  firebase.database().ref('/User/' + `/${props.uid}/` + '/Year/' + schoolYear + `/${facultyTitle}/`).update({
    Name: facultyTitle + ' General',
    Faculty: facultyTitle,
    time: currenTime,
    schoool: displayName,

    Description: 'General group for all' + facultyTitle + 'students' ,
   
    // ...
  });

     
   firebase.database().ref('/User/' + `/${props.uid}/` + '/Year/' + `/${schoolYear}/` + '/General/').update({
    Name: displayName + ' ' + schoolYear,
    Faculty: facultyTitle,
    time: currenTime,
    schoool: displayName,
    Description: 'General group for all' + displayName + 'students' ,
   
    // ...
  }); 


  });
        }




   return(
   <div>

  
<div>
{ userProfile === 'Business' ?<Text><b>{displayName}</b> {newCommunity} welcome to your bsuiness chat screen, Here you can add workers, talk to them and add jobs that needs to be done faster </Text>
: <Text><b>{displayName}</b> {newCommunity + yearProps} welcome to your schoool chat screen, Here you can add staffs, talk to them and add jobs that needs to be done faster </Text>}
<p>{loadingDescription}</p>

{ userProfile === 'Business' ? null : <div style={{display: 'flex', flexDirection: 'row', width: '100%'}} >
<ul>
 {schoolYearList.map(function(item){
     
         return (
 <Chip key={item.y}
        size={item.y == schoolYear ? "large" : "small"}
        color={item.y == schoolYear ? "secondary" : "primary"}
        label={item.y}
        onClick={() => setSchoolYear(item.y)}
        onDelete={handleYearChange}
      />
             
 )
    })}</ul>

 { props.uid == user.uid ?
<TextField
      label="Likely End year"
      value={universityYear}
      onChange={handleYearChange}
      keyboardtype='number-pad'
       autoFocus={true}
       type='number'
       variant='outlined'
     
    />: null}

{ props.uid == user.uid ?
    <Button onClick={addYear}>add year </Button> : null}

</div>
 }

{ userProfile === 'Business' ?


 <ul style={{listStyleType: 'none'}}>
{businessCommunityList.map(function(item){
     
         return (<li key={item.time}><div style={{display: 'flex', width: '80%', overflow: 'auto', justifyContent: item.avatar != user.photoURL? 'flex-start' : 'flex-end',  fontSize: 'calc(4px + 2vmin)', borderRadius: 10 , margin: 1, }}> 
              <Link to={item.displayName + '_' + item.time} ><Card style={{ width: '100%'}}  > <CardHeader
        avatar={
          <Avatar aria-label="recipe" src={user.photoURL}>
            
          </Avatar>
        }
        
        title={item.Title}
        subheader={'created by ' + item.displayName }
      /><CardMedia
        className={classes.media}
        image={item.Image}
        title={item.Title}
      />
}


<CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
{item.Description}    </Typography>
      </CardContent>      </Card></Link>

                </div></li> )
    })}

       </ul> :
       <div>{ !schoolYear ? <p> tap on any year above to see communities here</p> :
 <ul style={{listStyleType: 'none'}}>

{schoolCommunityList.map(function(item){
     
         return (<li key={item.time}><div style={{display: !item.Name ? 'none': 'flex', width: '80%', overflow: 'auto', justifyContent: item.avatar != user.photoURL? 'flex-start' : 'flex-end',  fontSize: 'calc(4px + 2vmin)', borderRadius: 10 , margin: 1, }}> 
              <Link to={ item.Name + '_' + schoolYear} ><Card style={{ width: '100%'}}  > <CardHeader
        avatar={
          <Avatar aria-label="recipe" src={displayPicture}>
            
          </Avatar>
        }
        
        title={item.Name}
        subheader={item.schoool }
      /><CardMedia
        className={classes.media}
        image={item.Image}
        title={item.Title}
      />



<CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
{item.Description}    </Typography>
      </CardContent>      </Card></Link>

                </div></li>
      
     )
    })}

       </ul> 

}</div>}


{ props.uid == user.uid ?
<IconButton onClick={() => setNewCommunity(!newCommunity)} >
 <ChatIcon />  
 </IconButton> : null}


{newCommunity == false ? null :<div style={{ display: 'flex', backgroundColor: 'grey', flexDirection: 'column' }}>
<Text> add new Communities here </Text>

<img src={media? URL.createObjectURL(media) : null} alt={media? media.name : null}/>      
   <label className="btn btn-default">
   <label for="file">Choose background picture, it can be a group photo of the team or somethig else, it can be changed</label>
        <input type="file"  onChange={handleImageAsFile}             accept="image/png, image/gif, image/jpeg, " />
      </label>


     

         
            
 <TextField
          id="outlined-link"
          label="Title"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='Fill in your Link'
          required
          value = {communityName}
         onChange={(e) => setCommunityName(e.target.value)}
          multiline
         
        /> 

        <TextField
          id="outlined-link"
          label="Title"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='Fill in your Link'
          required
          value = {communityDescription}
         onChange={(e) => setCommunityDescription(e.target.value)}
          multiline
         
        /> 
        <Button onClick={uploadStatus} >Create Community</Button>         

</div>}
</div>


<div>


{ !schoolYear ? <p> tap on any year above to see communities here</p> :
 <ul style={{listStyleType: 'none'}}>
    {comminityList.map(function(item){
             return (<li key={item.time}><div style={{display: !item.Name ? 'none': 'flex', width: '80%', overflow: 'auto', justifyContent: item.avatar != user.photoURL? 'flex-start' : 'flex-end',  fontSize: 'calc(4px + 2vmin)', borderRadius: 10 , margin: 1, }}> 
              <Link to={ props.uid + '_' + schoolYear + '_' + item.Name} ><Card style={{ width: '100%'}}  > <CardHeader
        avatar={
          <Avatar aria-label="recipe" src={displayPicture}>
            
          </Avatar>
        }
        
        title={item.Name}
        subheader={item.schoool }
      /><CardMedia
        className={classes.media}
        image={item.Image}
        title={item.Title}
      />



<CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
{item.Description}    </Typography>
      </CardContent>      </Card></Link>

                </div></li>)
    })}

       </ul> 

}

{ props.uid == user.uid ?
<IconButton onClick={() => setNewCommunity(!newCommunity)} >
 <ChatIcon />  
 </IconButton> : null }


{newCommunity == false ? null : !schoolYear ? <p> choose a year above to see the communities</p> : <div style={{ display: 'flex', backgroundColor: 'grey', flexDirection: 'column' }}>
<Text> add new Communities here </Text>

<img src={media? URL.createObjectURL(media) : null} alt={media? media.name : null}/>      
   <label className="btn btn-default">
        <input type="file"  onChange={handleImageAsFile}             accept="image/png, image/gif, image/jpeg, " />
      </label>


     

         
            
 <TextField
          id="outlined-link"
          label="Course Name"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='Course'
          required
          value = {communityName}
         onChange={(e) => setCommunityName(e.target.value)}
          multiline
         
        /> 


 <TextField
          id="outlined-link"
          label="Faculty"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='Faculty Name'
          required
          value = {facultyTitle}
         onChange={(e) => setFacultyTitle(e.target.value)}
         
         
        /> 

        <TextField
          id="outlined-link"
          label="Community Description"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='Tell your students what to expect'
          required
          value = {communityDescription}
         onChange={(e) => setCommunityDescription(e.target.value)}
          multiline
         
        /> 
        <Button onClick={uploadStatus} >Create Community</Button>         

</div>}
</div>
 

   </div>
  )
}

/*function ChatRoomLists (props) {

  const classes = useStyles();
const [display, setDisplay] = useState('flex');

      const [loading, setLoading] = useState(true);
            
     const [newCommunity, setNewCommunity] = useState(false);
  const [comminityList, setCommunityList] = useState([]);
  const [communityName, setCommunityName] = useState('');
  const [communityDescription, setCommunityDescription] = useState('');
  const [facultyTitle, setFacultyTitle] = useState('');
const [yearList, setYearList] = useState([]);
const [schoolYear, setSchoolYear]= useState('');

const uid = props.uid;

 
//const template = templateString.replace('{uids}', uids);








  return (
  <div>
{userProfile == 'Student' ? <div>

<div style={{display: 'flex', flexDirection: 'row', width: '100%'}} >

<ul style={{listStyleType: 'none'}}>
    {yearList.map(function(item){
             return (
 <Chip key={item.y}
        size={item.y == schoolYear ? "large" : "small"}
        color={item.y == schoolYear ? "secondary" : "primary"}
        label={item.y}
        onClick={() => setSchoolYear(item.y)}
      />
             )}
             )}
</ul>



</div>

{ !schoolYear ? <p> tap on any year above to see communities here</p> :
 <ul style={{listStyleType: 'none'}}>
    {comminityList.map(function(item){
             return (<li key={item.time}><div style={{display: !item.Name ? 'none': 'flex', width: '80%', overflow: 'auto', justifyContent: item.avatar != user.photoURL? 'flex-start' : 'flex-end',  fontSize: 'calc(4px + 2vmin)', borderRadius: 10 , margin: 1, }}> 
              <Link to={ props.uid + '_' + schoolYear + '_' + item.Name} ><Card style={{ width: '100%'}}  > <CardHeader
        avatar={
          <Avatar aria-label="recipe" src={user.photoURL}>
            
          </Avatar>
        }
        
        title={item.Name}
        subheader={item.schoool }
      /><CardMedia
        className={classes.media}
        image={item.Image}
        title={item.Title}
      />



<CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
{item.Description}    </Typography>
      </CardContent>      </Card></Link>

                </div></li>)
      }
       )}

       </ul> 

}




</div>: userProfile == 'Business'? null : null}

         <div style={{ width: 'auto', height: 'auto',  justifyContent: 'flex-end', alignSelf: 'center', borderRadius: 30, backgroundColor: 'seagreen', }} > 

       <Link to="exploreCommunities">Explore Communities</Link>
       <Link to="">personal communities  </Link>


</div>
  </div>

  )
}

*/


  function Feeds () {
    const NotFound = () => <p>Sorry, nothing here</p>;

    return (
    <div>
    {!complete ? <NewUser/> :

<div className='Apps'>
      





<SideNavsss/>
<SideNavss/>


<div className='community'style={{flex:8, backgroundColor: 'whiteSmoke', marginTop: '2.5%', padding: '2%', width: '80%', left: '5%', justifyContent: 'center'}} >
<Router>
 <Community exact path='/'>
 <CommunityScreen exact path="/" >
               <CommunityList exact path='/' />
<ChatRoomList exact path=":uid" >
   <OutsideChatRoom exact path='/' />
            <InsideChatRoom exact path=":name" />
          </ChatRoomList>        
</CommunityScreen>
      <Class exact path="exploreCommunities" />
      </Community>
    <Chats exact path="Chats" >
              <FriendMessagesScreen exact path="/" >
                  <Nothing exact path="/" />
                  <Feds exact path=":uid" />
              </FriendMessagesScreen>
    </Chats>
     

        <NotFound default />
</Router>




</div>

<Accordionsss/>
<Accordionss/>

</div>
}
</div>
    )
  }



function Chats () {
  return (
<Router>
 <FriendMessagesScreen exact path="/" >
 <Feds exact path=":uid" />
                   <Nothing exact path="/" />
                   </FriendMessagesScreen>
                     </Router>

  )
}



function Class (props) {
  return (
  <div><p> this is inside a class {props.uid}</p> </div>) 
}


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}




function Community () {
  return (
  <div>
<Router>
      <CommunityScreen exact path="/" >
               <CommunityList exact path='/' />
<ChatRoomList exact path=":uid" >
   <OutsideChatRoom exact path='/' />
            <InsideChatRoom exact path=":name" />
          </ChatRoomList>        
</CommunityScreen>
      <Class exact path="exploreCommunities" />
    </Router>

 
</div>
  )
}


function VerificationScreen () {

  


 




 

  

  return (
    <div style={{ width: '100%', top: '15%',  justifyContent: 'space-around', display: 'flex', flexDirection: 'column', }}>
    <SlideShows/>
    </div>

  )
}




  function Explore () {

    return(
    <div>
<div className='youtubevideo'>
  <div style={{ display: 'flex',  marginTop: '1%', marginLeft: '1%',  alignSelf: 'center', borderBottomRightRadius: '1vh', alignItems: 'center', borderBottomLeftRadius: '1vh',justifyContent: 'center', flexDirection: 'column', backgroundColor: 'orange', width: '100%', height: 'auto'}}>
  <iframe style={{width: '100%', height: 'auto', border:'none'}}  title="Iframe Example"
src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0">
</iframe>
    <p style={{color: 'black'}}>About Learners <code>web</code></p>
  </div>

  <div style={{ display: 'flex',  marginTop: '1%',marginLeft: '1%',  alignSelf: 'center', borderBottomRightRadius: '1vh', alignItems: 'center', borderBottomLeftRadius: '1vh',justifyContent: 'center', flexDirection: 'column', backgroundColor: 'orange', width: '100%', height: 'auto'}}>
  <iframe style={{width: '100%', height: 'auto', border:'none'}}  title="Iframe Example"
src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0">
</iframe>
    <p style={{color: 'black'}}>About Learners <code>web</code></p>
  </div>

  <div style={{ display: 'flex',  marginTop: '1%', marginLeft: '1%',  alignSelf: 'center', borderBottomRightRadius: '1vh', alignItems: 'center', borderBottomLeftRadius: '1vh',justifyContent: 'center', flexDirection: 'column', backgroundColor: 'orange', width: '100%', height: 'auto'}}>
  <iframe style={{width: '100%', height: 'auto', border:'none'}}  title="Iframe Example"
src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0">
</iframe>
    <p style={{color: 'black'}}>About Learners <code>web</code></p>
  </div>
</div>

<div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between'}}>
  <div style={{maxHeight: '7vh', minHeight: '4vh', display: 'flex', padding: '1%', marginTop: '5%', width: '50%', alignSelf: 'center', borderRadius: '10vh',justifyContent: 'center', flexDirection: 'row', backgroundColor: 'orange'}}>
    <ExploreRoundedIcon />
    <p>Explore</p>
  </div>

  <div style={{maxHeight: '7vh', minHeight: '4vh', display: 'flex', padding: '1%', marginTop: '5%', width: '50%', alignSelf: 'center', borderRadius: '10vh',justifyContent: 'center', flexDirection: 'row', backgroundColor: 'green'}}>
    <Link to="/Explore/Courses" ><AssignmentIcon />
    <p>Courses</p></Link>
  </div>
</div>


<div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between', marginTop: '10%', zIndex: 5}}>
  <div style={{backgroundColor: '#72C77A',  borderRadius: '2vh', textAlign: 'center', paddingLeft: '5%', paddingRight: '5%', alignSelf: 'center', }}>
    <p>New Articles</p>
  </div>
  
  <div className='youtubevideo'>
  <div style={{ display: 'flex',  marginTop: '1%', marginLeft: '1%',  alignSelf: 'center', borderBottomRightRadius: '1vh', alignItems: 'center', borderBottomLeftRadius: '1vh',justifyContent: 'center', flexDirection: 'column', backgroundColor: 'orange', width: '100%', height: 'auto'}}>
  <iframe style={{width: '100%', height: 'auto', border:'none'}}  title="Iframe Example"
src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0">
</iframe>
    <p style={{color: 'black'}}>About Learners <code>web</code></p>
  </div>

  <div style={{ display: 'flex',  marginTop: '1%',marginLeft: '1%',  alignSelf: 'center', borderBottomRightRadius: '1vh', alignItems: 'center', borderBottomLeftRadius: '1vh',justifyContent: 'center', flexDirection: 'column', backgroundColor: 'orange', width: '100%', height: 'auto'}}>
  <iframe style={{width: '100%', height: 'auto', border:'none'}}  title="Iframe Example"
src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0">
</iframe>
    <p style={{color: 'black'}}>About Learners <code>web</code></p>
  </div>

  <div style={{ display: 'flex',  marginTop: '1%', marginLeft: '1%',  alignSelf: 'center', borderBottomRightRadius: '1vh', alignItems: 'center', borderBottomLeftRadius: '1vh',justifyContent: 'center', flexDirection: 'column', backgroundColor: 'orange', width: '100%', height: 'auto'}}>
  <iframe style={{width: '100%', height: 'auto', border:'none'}}  title="Iframe Example"
src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0">
</iframe>
    <p style={{color: 'black'}}>About Learners <code>web</code></p>
  </div>
</div>
  </div>

</div>




    )
  }


  function Courses () {

const [coursesModal, setCoursesModal] = useState(true);


function AddCourse () {

  const [title, setTitle] = useState('');
  const [description, setDescription ] = useState('');
  const [outline, setOutline] = useState(true);
  const [disLiked, setDisLiked] = useState(true);
  const [posterColor, setPosterColor] = useState('lightgrey');
  const [videoTitles, setVideoTitles] = useState('');
  const [videoDescriptions, setVideosDescriptions] = useState('');



const allInputs = {imgUrl: ''};
    const [imageAsFile, setImageAsFile] = useState('');
    const [videoAsFile, setVideoAsFile] = useState('');
    const [imageAsUrl, setImageAsUrl] = useState(allInputs);
    const [media, setMedia] = useState(null);
    const [videoMedia, setVideoMedia] = useState(null);
    const [imageType, setImageType] = useState('');
    const [videoType, setVideoType] = useState('');
    const [videoMedias, setVideoMedias] = useState([]);



const [uploadArray, setUploadArray] = useState([]);


    const [imagesAsFile, setImagesAsFile] = useState('');
    const [videosAsFile, setVideosAsFile] = useState('');
        const [medias, setMedias] = useState(null);
            const [videosMedia, setVideosMedia] = useState(null);




 const handleImageAsFile = (e) => {
      const image = e.target.files[0]
      setImageAsFile(imageFile => (image));
      setMedia(image);

  }

  const handleImagesAsFile = (e) => {
      const image = e.target.files[0]
      setImagesAsFile(imagesFile => (image));
      setMedias(image);

  }

   const handleVideoAsFile = (e) => {
      const image = e.target.files[0]
      setVideoAsFile(imageFile => (image));
      setVideoMedia(image);

  }


   const handleVideosAsFile = (e) => {
      const image = e.target.files[0]
      setVideosAsFile(imageFile => (image));
      setVideosMedia(image);

  }

const currentTime = new Date().getTime();


 async function NewVideos () {

 setLoadingDescription('uploading your video, do not cancel');


      await firebase.storage().ref('/User/' + user.uid + '/Testing/' + currentTime ).put(videosAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
  
});

      await  firebase.storage().ref('/User/' + user.uid + '/Testing/' + currentTime).getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);

    firebase.database().ref('/User/' + user.uid + '/CourseDraft/' + '/Videos/'   + currentTime).update({ videos: downloadURL })
  });

   setLoadingDescription('uploading your poster, title and descrition, do not cancel');


    await firebase.storage().ref('/User/' + user.uid + '/Testing/' ).put(imagesAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
  
});

      await  firebase.storage().ref('/User/' + user.uid + '/Testing/').getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);

    firebase.database().ref('/User/' + user.uid + '/CourseDraft/' + '/Videos/'  + currentTime ).update({ posters: downloadURL, titles: videoTitles, createdAt: currentTime, Description: videoDescriptions })
  });
       
     

  }


   useEffect(() => {

    const onChildAdd = firebase.database().ref('/User/' + user.uid + '/CourseDraft/' + '/Videos/' ).orderByChild('createdAt').on('value', function(snapshot) {
const courseVideoList = [];

snapshot.forEach(function(userSnapshot) {
const id = userSnapshot.key;
const list = userSnapshot.val();

courseVideoList.push(list);



});
 
setVideoMedias(courseVideoList);

});




 return () =>
    firebase.database().ref('/User/' + user.uid + '/CourseDraft/' )
        .off('value', onChildAdd);


}, []);




const config = {
  public_key: 'FLWPUBK_TEST-7e2f3de2121dc2429f49d0c8916237c5-X',
  tx_ref: Date.now(),
  amount: 5000,
  currency: 'NGN',
  payment_options: 'card,mobilemoney,ussd',
  customer: {
    email: user.email,
    phonenumber: '',
    name: displayName,
  },
  customizations: {
    title: 'course Upload',
    description: 'Payment for course upload',
    logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
  },
};

  const [paymentStatus, setPaymentStatus] = useState('not paid');
  const [loadingDescription, setLoadingDescription] = useState('');
  const handleFlutterPayment = useFlutterwave(config);

  

const [courseTitle, setCourseTitle] = useState('');
const [courseDescription, setCourseDescription] = useState('');
const [coursePosterColor, setCoursePosterColor] = useState('');
const [introPoster, setIntroPoster] = useState(null);
const [introVideo, setIntroVideo] = useState(null);

      useEffect(() => { 
      const onValueChange = firebase.database().ref('/User/' + user.uid + '/CourseDraft/' ).on('value', function(snapshot) {
setCourseTitle(snapshot.val().title);
setCourseDescription(snapshot.val().description);
setCoursePosterColor(snapshot.val().posterColor);
setIntroPoster(snapshot.val().poster);
setIntroVideo(snapshot.val().video);

    // ...
    });
    

    
     return () =>
      firebase.database()
        .ref('/User/' + user.uid + '/CourseDraft/')
        .off('value', onValueChange);
    }, [user.uid])


    async function addIntroVideos () {
             setLoadingDescription('uploading your video, do not cancel');


      await firebase.storage().ref('/User/' + user.uid + '/Testing/' ).put(videoAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
  
});

      await  firebase.storage().ref('/User/' + user.uid + '/Testing/').getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);

    firebase.database().ref('/User/' + user.uid + '/CourseDraft/').update({posterColor: posterColor, video: downloadURL })
  });
       setLoadingDescription('uploading your poster, do not cancel');


 await firebase.storage().ref('/User/' + user.uid + '/Testing/' ).put(imageAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
  
});

      await  firebase.storage().ref('/User/' + user.uid + '/Testing/').getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);

    firebase.database().ref('/User/' + user.uid + '/CourseDraft/').update({posterColor: posterColor, poster: downloadURL, })
  });

       setLoadingDescription('');


    }

const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
 
 async function uploadCourse () {

         setLoadingDescription('Uploading Intro page contents');


    firebase.database().ref('/Course/' + currentTime).update({
      posterColor: coursePosterColor,
      poster: introPoster,
      video: introVideo,
      description: courseDescription,
      title: courseTitle,

       })

         setLoadingDescription('Uploading your ' + videoMedias.length + ' ' + 'videos');


    firebase.database().ref('/Course/' + currentTime ).update({
      videoMedias
     
       })


 }


  return(
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '2%', width:'100%' }}> 



<div style={{display: 'flex', flexDirection: window.screen.availHeight > window.screen.availWidth ? 'column' : 'row', justifyContent: 'space-evenly',  width: '100%', alignItems: 'center', padding: '2%' }}>

 <div style={{  display: 'flex', width: '100%', flexDirection: 'column', backgroundColor: 'lightgrey', borderRadius: 10, padding: '2%', marginRight: '3%', justifyContent: 'flex-start',  }} > 
 
<div style={{backgroundColor: 'tomato', width: 'auto', borderBottomRightRadius: 15, borderBottomLeftRadius: 15, paddingBottom: '2%' }} ><b style={{textAlign: 'center'}} ><b style={{backgroundColor: 'whiteSmoke', borderRadius: 100, fontSize: 'calc(4px + 3vmin)', padding: '10%' }} >1</b> Design intro page</b></div>

 <div style={{ minWidth: '50%', display: 'flex', flexDirection: 'row',  justifyContent: 'space-around', marginTop: '4%' }}><TextField
          id="Course Name"
          label="Course Name"
          type="text"
         
          variant="outlined"
          placeholder='use a professional Name'
          required
          value = {title}
          autoFocus
         onChange={(e) => setTitle(e.target.value)}
        /><IconButton onClick={() => firebase.database().ref('/Course/' + user.uid + '/CourseDraft/').update({title: title})} ><SaveIcon /></IconButton></div>

 <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignSelf: 'center', marginTop: '2%', justifyContent: 'space-around'}}><TextField
          id="outlined-title"
          label="Course description"
          type="text"
         multiline
          variant="outlined"
          placeholder='how will what they learn here improve their Knowledge'
          required
          value = {description}
         onChange={(e) => setDescription(e.target.value)}
        /><IconButton onClick={() => firebase.database().ref('/Course/' + user.uid + '/CourseDraft/').update({description: description})} ><SaveIcon /></IconButton></div>

 <div style={{ width: '100%', display: 'flex', flexDirection: 'row', backgroundColor: 'grey', borderRadius: 10}} >
       
       <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', alignContent: 'center',}} > <p>Intro video</p>


<label htmlFor="filePicker" >
<AddAPhotoIcon onClick={handleClick}/>
</label>
<input id="filePicker" style={{visibility:"hidden", width: '1vh'}} onChange={handleVideoAsFile}  accept=" video/mp4, video/3gp" type={"file"} />
</div>
     
           <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', alignContent: 'center',  borderStyle: 'solid', borderWidth: '2px', borderColor: 'lightgrey' }} > <p style={{textAlign: 'center'}} > Intro poster </p>

<label htmlFor="imgpicker" >
<AddAPhotoIcon onClick={handleClick}/>
</label>
<input id="imgpicker" style={{visibility:"hidden", width: '1vh'}} onChange={handleImageAsFile}  accept="image/png, image/gif, image/jpeg, " type={"file"} />
 
</div>

<div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', alignContent: 'center'}} >
<p> page color</p>
<input type="color" value={posterColor}  onChange={(e) => setPosterColor(e.target.value)}
/>
</div>

</div>
<p>{loadingDescription}</p>
<Button onClick={addIntroVideos} >upload Intro Video</Button>
        </div>


        <div style={{ borderRadius: 10, display: 'flex', flexDirection: 'column', height: 'auto', backgroundColor: !coursePosterColor ? posterColor : coursePosterColor, width: '100%', padding: '2%' }} >
        <video src={introVideo} poster={introPoster} alt={courseTitle} width='100%' controls controlsList='nodownload nofullscreen noremoteplayback' />      

        <b style={{fontSize: 'calc(3px + 2vmin)'}} >{courseTitle}</b>

        <div style={{display: 'flex', flexDirection: 'row', width: '100%',justifyContent: 'space-around' }} >


        <IconButton onClick={() => setDisLiked(!disLiked)} >
          <FavoriteIcon color={ disLiked === true  ?"secondary" : 'disabled'}   />
        </IconButton>
       


       { courseDescription === '' ? null : <IconButton          
          onClick={() => setOutline(!outline) } > 
          <ExpandMoreIcon />
        </IconButton>}

<IconButton onClick={() => setDisLiked(!disLiked)} >
        <FontAwesomeIcon icon={faHeartBroken} color={ disLiked === true  ?"grey" : 'red[500]'} />  
        </IconButton> 

         </div>  

         <div style={{ display: outline === true ? 'none' : 'flex', width: '100%', flexDirection: 'column'  }} > <p style={{fontSize: 'calc(2px + 2vmin)'}}>{courseDescription}</p> <Button>div Course</Button> </div>
        </div>
</div>

<p> Edit the course page</p>

<div>

 <div style={{ borderRadius: 10, display: 'flex', flexDirection: 'column', height: 'auto', backgroundColor: posterColor,  width: '100%', padding: '2%' }} >
        <video src={introVideo} poster={introPoster} alt={courseTitle} width='100%'controls controlsList='nodownload nofullscreen noremoteplayback' />      

        <b style={{fontSize: 'calc(3px + 2vmin)'}} >{courseTitle}</b>

        <div style={{display: 'flex', flexDirection: 'row', width: '100%', height: 'auto', justifyContent: 'space-around' }} >


        <div style={{display: 'flex', flexDirection: 'column', }} >

        <IconButton onClick={() => setDisLiked(!disLiked)} style={{display: 'flex', flexDirection: 'row'}} >
        <p>234</p>
          <FavoriteIcon color={ disLiked === true  ?"secondary" : 'disabled'}   />
        </IconButton>
       


      

<IconButton onClick={() => setDisLiked(!disLiked)}  style={{display: 'flex', flexDirection: 'row'}} >
<p>2</p>
        <FontAwesomeIcon icon={faHeartBroken} color={ disLiked === true  ?"grey" : 'red[500]'} />  
        </IconButton> 

         </div>  

         <div style={{ display: 'flex', width: '100%', flexDirection: 'column'  }} > <p style={{fontSize: 'calc(2px + 2vmin)'}}>{courseDescription}</p></div>
         </div>

<ul style={{ display: 'flex', width: '100%', padding: '2%', flexDirection: 'column' }}  >

{videoMedias.map(function(item){

      
      return (
  <div style={{ display: 'flex', width: '100%', borderRadius: 10, backgroundColor: 'lightgrey', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'  }} key={item.createdAt} >
  <video src={item.videos} poster={item.posters} alt={item.titles} width='80%' style={{padding: '2%'}} controls controlsList='nodownload noremoteplayback' />      
<b style={{fontSize: 'calc(3px + 2vmin)'}} >{item.titles}</b>  <p style={{fontSize: 'calc(2px + 2vmin)'}} >{item.Description}</p>
    </div>
  

)
}
)}
  
 
</ul>


         </div>


         <div style={{  display: 'flex', width: '100%', flexDirection: 'column', backgroundColor: 'lightgrey', borderRadius: 10, padding: '2%', marginTop: '3%', justifyContent: 'flex-start',  }} > 
 
<div style={{backgroundColor: 'sienna', width: 'auto', borderBottomRightRadius: 15, borderBottomLeftRadius: 15, paddingBottom: '2%' }} ><b style={{textAlign: 'center'}} ><b style={{backgroundColor: 'whiteSmoke', borderRadius: 100, fontSize: 'calc(4px + 3vmin)', padding: '10%' }} >2</b>Add Videos</b></div>



 <div style={{ width: '100%', display: 'flex', flexDirection: 'row', padding: '2%',}} >
 <div style={{ width: 'auto', display: 'flex', flexDirection: 'column', justifyContent:'space-evenly', padding: '2%', backgroundColor: 'grey', borderRadius: 10 }} >
       
       <div style={{ width: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', alignContent: 'center', borderStyle: 'solid', borderWidth: '2px', borderColor: 'lightgrey' }} > <p>Intro video</p>


<label htmlFor="videoPicker" >
<AddAPhotoIcon onClick={handleClick}/>
</label>
<input id="videoPicker" style={{visibility:"hidden", width: '1vh'}} onChange={handleVideosAsFile}    accept=" video/mp4, video/3gp" type={"file"} />
</div>
     
           <div style={{ width: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', alignContent: 'center',  borderStyle: 'solid', borderWidth: '2px', borderColor: 'lightgrey' }} > <p style={{textAlign: 'center'}} > Intro poster </p>

<label htmlFor="imgspicker" >
<AddAPhotoIcon onClick={handleClick}/>
</label>
<input id="imgspicker" style={{visibility:"hidden", width: '1vh'}} onChange={handleImagesAsFile}  accept="image/png, image/gif, image/jpeg, " type={"file"} />
 
</div>
</div>


 <div style={{ width: '100%', heigth: '100%', display: 'flex', flexDirection: 'column',  padding: '2%', borderRadius: 10 }} >


 <div style={{ minWidth: '50%', display: 'flex', flexDirection: 'row',  justifyContent: 'space-around', marginTop: '4%' }}>
   <TextField
          id="outlined-title"
          label="Video Title"
          type="text"
         
          variant="outlined"
          placeholder='use a concise title'
          required
          value = {videoTitles}
          
         onChange={(e) => setVideoTitles(e.target.value)}
        /> 
        </div>

 <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignSelf: 'center', marginTop: '2%', justifyContent: 'space-around'}}>

        <TextField
          id="outlined-title"
          label="Video Description"
          type="text"
         
          variant="outlined"
          placeholder='tell us briefly about the video'
          required
          value = {videoDescriptions}
          
         onChange={(e) => setVideosDescriptions(e.target.value)}
        /> 
        </div>
        </div>

</div>
<p>{loadingDescription}</p>
<Button onClick={NewVideos} >upload Intro Video</Button>
<p>you have added {videoMedias.length} { videoMedias.length === 1 ? 'video': 'videos'}</p>

        </div>






{paymentStatus == 'paid' ?  <div> <Button
        variant="contained"
        color="primary"
        onClick={uploadCourse}
        disabled={loadingDescription !== '' ? true : false}
      >Upload</Button>
      <p>{loadingDescription}</p>
      <p> tap on the button, once it disappears, your status has been uploaded. this is your {postCount} post</p>
      </div> : <Button
        onClick={() => {
          handleFlutterPayment({
            callback: (response) => {
               console.log(response);
               setPaymentStatus('paid');
                closePaymentModal() // this will close the modal programmatically
            },
            onClose: () => <p> payment not successfull </p>,
          });
        }}
      >
        Pay $15
      </Button>
 }
 <p>{loadingDescription}</p>
</div>
</div>





  )
}




function CoursesStream (item) {

  return(
<li key={item.createdAt}>
<div><p>{item.title}</p></div>
</li>
  )
}


function CoursesList () {

return(
<div>

<ul >
{coursesList.map(function(item){

      
      return (


<CoursesStream key={item.createdAt} createdAt={item.createdAt} />

 )
}
)}
      </ul>
      <Divider />
</div>

)
}


    return (
<div style={{flex:8, backgroundColor: 'whiteSmoke', padding: '1%', width: '80%', left: '0%', marginTop: '10%' }} >
    {coursesModal === true ? <CoursesList /> : <AddCourse/>}


<Button onClick={() => setCoursesModal(!coursesModal)} >{coursesModal === true ? 'add your course'  : 'div courses'}</Button>


<Link to={user.uid} ><p>div this course</p></Link>
    </div>

    )

  }

  function CoursesDetails () {

const [coursesModal, setCoursesModal] = useState(true);



    return (
<div style={{flex:8, backgroundColor: 'whiteSmoke', padding: '1%', width: '80%', left: '0%', marginTop: '10%' }} >
    {coursesModal === true ? <p> your courses should be here</p> : <p>build your course here</p>}



<div><Button onClick={() => setCoursesModal(!coursesModal)} >{coursesModal === true ? 'add your course'  : 'div courses'}</Button>
    </div>
    </div>

    )

  }

  function LowerPart () {

 

  return (
    <div className='Apps'>

<div style={{flex:8, backgroundColor: 'whiteSmoke', padding: '1%', width: '80%', left: '0%',  }} >


<Router>

<AddStatus exact path="/AddStatus" displayName={displayName} displayPicture={displayPicture} userProfile={userProfile} postCount={postCount} location={location} school={school} />
<Explore exact path="/" />
<Courses exact path="/Courses" >
    <CoursesDetails path=":uid"/>
</Courses>
</Router>
</div>



<Accordionsss/>

<Accordionss/>


</div>
  )
 }


   
 const classes = useStyles();
 const [anchorEl, setAnchorEl] = React.useState(null);

 const handleClick = (event) => {
   setAnchorEl(event.currentTarget);
 };

 const handleClose = () => {
   setAnchorEl(null);
 };

 const open = Boolean(anchorEl);
 const ids = open ? 'simple-popover' : undefined;

 async function signOut () {
    await firebase.auth().signOut().then(function() {
  // Sign-out successful.
}).catch(function(error) {
  // An error happened.
});
  }


 

function Dashboard () {
return(
    <div className='Apps'>

<div style={{flex:8, backgroundColor: 'whiteSmoke', padding: '1%', width: '80%', left: '0%'}} >
<Router>
    <PersonalDashboard exact path=':uid'/>
    </Router>
</div>
<Accordionsss/>

<Accordionss/></div>
)
}
const [userId, setUserId] = useState('')


function PersonalDashboardScreen (props) {

  return ( <div class='fullDashboard'>
<h3> Personal Dashboard</h3>
<div class='Dashboard'>
<div>
  <Avatar src={displayPicture} alt='profile' variant="rounded" size="20" />

  <div><p>{displayName}</p><p>{school}</p></div>
  </div>
</div>
  </div>)
}

function OthersDashboard (props) {
  
 

 
  return ( <p>{userId} others Dashboard </p>)
}

function PersonalDashboard (props) {

if (props.uid === user.uid) {
  setUserId(props.uid);
  return <PersonalDashboardScreen/>
}else{
   setUserId(props.uid);
  return <OthersDashboard/>
}

}

const templateString = "User/{uids}";
      const uids = user.uid;

const template = templateString.replace('{uids}', uids);
 const prevScrollY = useRef(0);

  /*const [goingUp, setGoingUp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;
      console.log(goingUp, currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);*/

   if (waiting === true) {
    return <Text>Knowledge makes one noble, are you noble yet?</Text>;
  }

return (
<div className="App" >
<header className="App-header" style={{ position: 'sticky'}} >

 <Link to=''><img src={logos} className="App-logo" alt="logo" /></Link>
  <p className='headertext'>Learners Hubs <code className='web'>web</code>  </p>

  <div style={{justifyContent: 'flex-end', width: '100%', display: 'flex', marginLeft: '1%', flexDirection:'row', alignSelf: 'center', alignContent: 'center', alignItems: 'center'}}> 
    <Link to="Feeds" className="header-icons" ><ForumIcon/></Link>
  <Link to='Explore' className="header-icons" ><ExploreIcon/></Link>

    

         <img src={displayPicture}  onClick={handleClick} aria-describedby={ids} className="App-user" alt='profile' />

<Popover
        id={ids}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography className={classes.typography}>
 <div><Link to={template}>Dashboard</Link> 
   <Button variant="contained" color="primary" onClick={signOut}> 
        SignOut
      </Button>
      </div>
        </Typography>
      </Popover>
</div>
</header>

<Router ref={prevScrollY} className="router" >
<VerificationScreen exact path='/'>
<PostInfo exact path='/post' />
</VerificationScreen>

      <LowerPart exact path="/Explore" >
<AddStatus exact path="/AddStatus"/>
<Explore exact path="/" />
<Courses exact path="/Courses" />
      </LowerPart>
      <Feeds exact path="Feeds" >
      <Community exact path='/'>
 <CommunityScreen exact path="/" >
               <CommunityList exact path='/' />
<ChatRoomList exact path=":uid" >
   <OutsideChatRoom exact path='/' />
            <InsideChatRoom exact path=":name" />
          </ChatRoomList>        
</CommunityScreen>
      <Class exact path="exploreCommunities" />
      </Community>
    <Chats exact path="Chats" >
              <FriendMessagesScreen exact path="/" >
                  <Nothing exact path="/" />
                  <Feds exact path=":uid" />
              </FriendMessagesScreen>
    </Chats>
     

      </Feeds>
      <Dashboard exact path='User' >
         <PersonalDashboard exact path=':uid'/>
         </Dashboard>
</Router>

</div>
);
}








































































































/*function WithoutUser ({userId}) {
  const [loading, setLoading] = useState(true); // Set loading to true on component mount
  const [userss, setUserss] = useState([]); 
  const [data, setData] = useState('');

  const [visible, setVisible] = useState(true);
  const [learnershubemail, setLearnershubemail] = useState('');
  const [errors, setErrors] = useState(false);
  const [password, setPassword] = useState('');
const [errorMessages, setErrorMessages] = useState('no errors');
const [errorCode, setErrorCode] = useState('no errors');
const [login, setLogin] = useState('flex');
const [signup, setSignup] = useState('none');

const [signinColor, setSigninColor] = useState('#E4E4E4');
const [signinText, setSigninText] = useState('#D99E69');
const [signinHeight, setSigninHeight] = useState('8vh');

const [loginColor, setLoginColor] = useState('#D99E69');
const [loginText, setLoginText] = useState('#E4E4E4');
const [loginHeight, setLoginHeight] = useState('10vh');


  var provider = new firebase.auth.GoogleAuthProvider();
  firebase.auth().useDeviceLanguage();

  async function googleSignIn () {
    await firebase.auth().signInWithRedirect(provider).then(function(result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      // ...
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
     
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;

      setErrorMessages(errorMessage);
  setErrorCode(errorCode);
      // ...
    });
  }
  
useEffect(() => {
                   


     firebase.database()
     .ref(`/User/`)
     .orderByChild('createdAt')
     .once('value', function(snapshot) {
snapshot.forEach(function(userSnapshot) {
const id = userSnapshot.key;
const userData = userSnapshot.val();
userData['id'] = id;
userss.push(userData); 
});
});



        
     setUserss(userss);
     if (loading) {
       setLoading(false);
     }
  
     console.log('User data: ', userss);
   

  
      
}, [])


useEffect(() => {

firebase.auth().getRedirectResult().then(function(result) {
  if (result.credential) {
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = result.credential.accessToken;
    var user = result.user.displayName;
    setData(user);
    console.log('users', data);

    
    // ...
  }
  // The signed-in user info.
 
}).catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // The email of the user's account used.
  var email = error.email;
  // The firebase.auth.AuthCredential type that was used.
  var credential = error.credential;
  setErrors(errorMessage);
  // ...
});

 

     }, [googleSignIn])

     var user = firebase.auth().currentUser;
     const classes = useStyles();




function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

 function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}



const { height, width } = useWindowDimensions();

  


     function NoUser () {

      const [displayStudentSignUp, setDisplayStudentSignUp] = useState('none');
      const [displayEntrepreneurSignUp, setDisplayEntrepreneurSignUp] = useState('none');
      const [displaySchoolsSignUp, setDisplaySchoolsSignUp] = useState('none');
      const [displayAcademicsSignUp, setDisplayAcademicsSignUp] = useState('none');
      
      const [signUpDivs, setSignUpDivs] = useState('flex');
      


function handleChange(event) {
   setLearnershubemail(event.target.value);
    
  }




function handlePasswordChange(event) {
   setPassword(event.target.value);
    
  }

useEffect(() => {
if (password.length <= 7) {
    setErrors(true);
   }else {
    setErrors(false);
   }
 }, [handlePasswordChange])


  async function CustomSignIn () {

     firebase.auth().signInWithEmailAndPassword(learnershubemail, password).catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // ...
  setErrorMessages(errorMessage);
  setErrorCode(errorCode);
});
   }

   async function CustomSignUp () {

     firebase.auth().createUserWithEmailAndPassword(learnershubemail, password).catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // ...
  setErrorMessages(errorMessage);
  setErrorCode(errorCode);
});

   } 

  async function CustomAnonymously () {

    firebase.auth().signInAnonymously().catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // ...
});
   }



function logins () {
  setLogin('flex');
  setSignup('none');
  setSigninColor('#E4E4E4');
  setSigninText('#D99E69');
  setSigninHeight('8vh');
  setLoginColor('#D99E69');
  setLoginText('#E4E4E4');
  setLoginHeight('10vh');


}

function signups () {
  setLogin('none');
  setSignup('flex');
  setSigninColor('#D99E69');
  setSigninText('#E4E4E4');
  setSigninHeight('10vh');
  setLoginColor('#E4E4E4');
  setLoginText('#D99E69');
  setLoginHeight('8vh');

}

function LoginInstructions () {

  return(
<div>
<div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Schools</p><p style={{color: '#D13939'}} > must begin with <b>admin@</b></p></div>
<div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Entrepreneurs</p><p style={{color: '#D13939'}} > must end with <b>@learnershub </b></p></div>
<div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Academic</p><p style={{color: '#D13939'}} >  must end with <b>@schoolname </b></p></div>
</div>
    )
}


function StudentSignUpEvent () {
  setDisplayStudentSignUp('flex');
  setDisplayEntrepreneurSignUp('none');
  setDisplaySchoolsSignUp('none');
  setDisplayAcademicsSignUp('none');
  setSignUpDivs('none');

}

function EntrepreneurSignUpEvent () {
  setDisplayStudentSignUp('none');
  setDisplayEntrepreneurSignUp('flex');
  setDisplaySchoolsSignUp('none');
  setDisplayAcademicsSignUp('none');
  setSignUpDivs('none');
}

function SchoolsSignUpEvent () {
  setDisplayStudentSignUp('none');
  setDisplayEntrepreneurSignUp('none');
  setDisplaySchoolsSignUp('flex');
  setDisplayAcademicsSignUp('none');
  setSignUpDivs('none');

}

function AcademicsSignUpEvent () {
  setDisplayStudentSignUp('none');
  setDisplayEntrepreneurSignUp('none');
  setDisplaySchoolsSignUp('none');
  setDisplayAcademicsSignUp('flex');
  setSignUpDivs('none');

}

function CancelSignUpEvents () {
  setDisplayStudentSignUp('none');
  setDisplayEntrepreneurSignUp('none');
  setDisplaySchoolsSignUp('none');
  setDisplayAcademicsSignUp('none');
  setSignUpDivs('flex');
}

function StudentSignUp () {

  return(
    <div style ={{ display: displayStudentSignUp, justifyContent: 'center', flexDirection: 'column', backgroundColor: '#C0E8C4', borderRadius: 10}}>
    <div style ={{ display: 'flex', justifyContent: 'center', flexDirection: 'row',}}>
    <div style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', backgroundColor: 'grey', padding: '3%'}}>
        <p style={{fontSize: `calc(4px + 1vmin)`, color: 'white', backgroundColor: '#EC3F3F', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}} onClick={CancelSignUpEvents}>Back</p>
        <p style={{fontSize: `calc(4px + 4vmin)`, color: '#C0E8C4', padding: '1%', textAlign: 'center'}}><b>Dear Student or Alumni</b></p>
        <p style={{fontSize: `calc(4px + 3vmin)`, color: 'white', backgroundColor: '#72C77A', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}}>Reminders</p>

    </div>
<div style={{width: '100%', display: 'flex', flexDirection: 'column',fontSize: `calc(2px + 2vmin)`, padding: '2%'}}>
    <ul>
      <li>There is button below that requires a Google Account</li>
      <li><b> When you sign in with this email, we will collect from Google your </b>
         <ul> <li>full name</li>
              <li>display picture</li>
              <li>Email</li>
              <li>unique identification number (uid)</li>
          </ul>      
      </li>
      
      
    <li> <b>As such, if you dont already have one, create a google account with</b>
          <ul><li>Your real and personal name</li>
          <li>A profile picture with your portrait with your faculty building in the background</li></ul>
          </li>
     


    </ul>
    <Button variant="contained" color="primary" onClick={googleSignIn}>
        Google Login
      </Button>
<p style={{padding: '3%', fontSize: `calc(2px + 1vmin)`}}>Please follow these reminders, for easy identification by your CourseMates when you log in, if your CourseMates cant identify you, they will request for your account to be blocked</p>
</div>
</div>
 </div>
  )
}


function EntrepreneurSignUp () {

const [entrpreneurLearnershubEmail, setEntrpreneurLearnershubEmail] = useState('');
const [entrepreneurLearnershubPassword, setEntrepreneurLearnershubPassword] = useState('');
const [entrepreneurErrorMessages, setEntrepreneurErrorMessages] = useState('no error');
const [entrepreneurErrorCode ,setEntrepreneurErrorCode] = useState('no error');
const [emailErrors, setEmailErrors] = useState(false);
const [passwordErrors, setPasswordErrors] = useState(false);

  function handleEntrepreneurEmailChange(event) {
    setEntrpreneurLearnershubEmail(event.target.value);
     
   }
 
 
 
   useEffect(() => {
 if (entrpreneurLearnershubEmail.includes("@learnershub.com")) {
     setEmailErrors(false);
    }else {
     setEmailErrors(true);
    }
  }, [handleEntrepreneurEmailChange])
 
 function handleEntrpreneurPasswordChange(event) {
    setEntrepreneurLearnershubPassword(event.target.value);
     
   }
 
 useEffect(() => {
 if (entrepreneurLearnershubPassword.length <= 5) {
     setPasswordErrors(true);
    }else {
      setPasswordErrors(false);
    }
  }, [handleEntrpreneurPasswordChange])
 
   const [incorrectEntry, setIncorrectEntry] = useState('must include @learnershub.com ')
 
   async function EntrepreneurSignUp () {
 
      firebase.auth().createUserWithEmailAndPassword(entrpreneurLearnershubEmail, entrepreneurLearnershubPassword).catch(function(error) {
   // Handle Errors here.
   var errorCode = error.code;
   var errorMessage = error.message;
   // ...
   setEntrepreneurErrorMessages(errorMessage);
   setEntrepreneurErrorCode(errorCode);
 });
    }

  return(
    <div style ={{ display: displayEntrepreneurSignUp, justifyContent: 'center', flexDirection: 'column', backgroundColor: '#E8E3C0', borderRadius: 10}}>
    <div style ={{ display: 'flex', justifyContent: 'center', flexDirection: 'row',}}>
    <div style={{ justifyContent: 'flex-start', display: 'flex', flexDirection: 'column', backgroundColor: 'grey', padding: '3%'}}>
        <p style={{fontSize: `calc(4px + 1vmin)`, color: 'white', backgroundColor: '#EC3F3F', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}} onClick={CancelSignUpEvents}>Back</p>
        <p style={{fontSize: `calc(4px + 4vmin)`, color: '#E8E3C0', padding: '1%', textAlign: 'center'}}><b>Dear Entrepreneur</b></p>
        <p style={{fontSize: `calc(4px + 3vmin)`, color: 'white', backgroundColor: '#C79F72', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}}>Reminders</p>

    </div>
<div style={{width: '100%', display: 'flex', flexDirection: 'column',fontSize: `calc(2px + 2vmin)`, padding: '2%'}}>
    <ul>
      <li>Signing in requires a learnershub email, and a password of your choice</li>
      <li><b> When you sign in with this email, Please, ensure to complete other details, for full identification, e.g. </b>
         <ul> <li>Business name</li>
              <li>Logo</li>
              <li>Background Image</li>
              <li>Business Location and other required information</li>
          </ul>      
      </li>
      
      
    <li> <b>With this account, you can , </b>
          <ul><li>connect with other Businesses</li>
          <li>display your ads in prefered locations</li>
          <li>Add Employees, to enable easy dispensing of information</li></ul>
          </li>
     


    </ul>
 <form  noValidate autoComplete="off">    
 <div style={{display: 'flex', alignSelf: 'center', alignItems: 'center', alignContent: 'center', padding: '3%', width: '100%', justifyContent: 'center', flexDirection: 'column',}}>
  
 <TextField
          id="Business email"
          label="Business email"
          type="email"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='businessname@learnershub.com'
          required
          value = {entrpreneurLearnershubEmail}
          onChange= {handleEntrepreneurEmailChange}
          helperText={incorrectEntry}
          error={emailErrors}
        />
<p>Email:- {entrpreneurLearnershubEmail}</p>
        <TextField
          id="school-password"
          label="Password"
          type="password"
          autoComplete="current-password"
          variant="outlined"
           placeholder='password'
           required
           value = {entrepreneurLearnershubPassword}
          onChange= {handleEntrpreneurPasswordChange}
          error={passwordErrors}
          helperText={'must be at least 6 characters '}
        />

        <Button
        variant="contained"
        color="primary"
        className={classes.button}
        sendIcon={<Icon>send</Icon>}
        onClick={EntrepreneurSignUp}
      >
        Sign Up
      </Button>
      </div>
</form>
       
<p style={{padding: '3%', fontSize: `calc(2px + 1vmin)`}}>Please follow these reminders, for easy identification of your business by those who might be interested in your business</p>
<div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Errors</p><p style={{color: '#D13939'}} >  {entrepreneurErrorMessages} <b>{entrepreneurErrorCode}</b></p></div>

</div>
</div>
 </div>
  )
}

function SchoolsSignUp () {

  return(
    <div style ={{ display: displaySchoolsSignUp, justifyContent: 'center', flexDirection: 'column', backgroundColor: '#D8C0E8', borderRadius: 10}}>
    <div style ={{ display: 'flex', justifyContent: 'center', flexDirection: 'row',}}>
    <div style={{ justifyContent: 'flex-start', display: 'flex', flexDirection: 'column', backgroundColor: 'grey', padding: '3%'}}>
        <p style={{fontSize: `calc(4px + 1vmin)`, color: 'white', backgroundColor: '#EC3F3F', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}} onClick={CancelSignUpEvents}>Back</p>
        <p style={{fontSize: `calc(4px + 4vmin)`, color: '#D8C0E8', padding: '1%', textAlign: 'center'}}><b>Dear School Representative</b></p>
        <p style={{fontSize: `calc(4px + 3vmin)`, color: 'white', backgroundColor: '#BF72C7', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}}>Reminders</p>

    </div>
<div style={{width: '100%', display: 'flex', flexDirection: 'column',fontSize: `calc(2px + 2vmin)`, padding: '2%'}}>
    <ul>
      <li>Your Sign in details will be  provided by a learners hub representative </li>
      <li><b> When you sign in with this email, You can </b>
         <ul> <li>create accounts for your staffs</li>
              <li>Send important information or updates to your Staffs, students or Alumni based on their course, year or faculty</li>
              <li>Assign staffs to different faculty and courses to enable them to moderate actions there</li>
          </ul>      
      </li>
      
      
    <li> <b>Procedure to get your sign in details </b>
          <ul><li>Send a message the <a href='https://www.instagram.com/inyangraphael/'>learners hub instagram page </a> with your instituitions account to get scheduled for an <i>instagram live video</i></li>
          <li>A learners hub team member will have to spaeak with a representative (vice chancellor, dean of student affairs or proprietor/proprietress) of your educational instituition in the live video </li>
          <li>We will ask them the questions found in the accompanying document</li></ul>
          </li>

    <li>
      <b>Reasons for the live video</b>
      <ul>
        <li><i>We are sure that you will understand the reasons for the live video</i></li>
        <li>Data is already being gathered for your school, as such, we want to be sure that we are handing it over to the school authorities and not some random human</li>
        <li>Your students and staffs will be rest assured that their data is handled by the school authorities</li>
        <li>Announcements and updates will be taken serioously if others knew that it is from the school authority</li>
        <li>The live video is planned to be fun, if you want it so, besides some of your students might want to watch you speak😉</li>
      </ul>
    </li>

    
     


    </ul>
    <Button variant="contained" color="primary" onClick={googleSignIn}>
        Print page
      </Button>
      <Button variant="contained" color="primary" onClick={googleSignIn}>
        Download questionaire
      </Button>
    <Button variant="contained" color="primary" onClick={googleSignIn}>
        Message us
      </Button>
<p style={{padding: '3%', fontSize: `calc(2px + 1vmin)`}}>❤❤❤ Thanks for following the reminders ❤❤❤</p>
</div>
</div>
 </div>
  )
}

function AcademicsSignUp () {

  return(
    <div style ={{ display: displayAcademicsSignUp, justifyContent: 'center', flexDirection: 'column', backgroundColor: '#D8C0E8', borderRadius: 10}}>
    <div style ={{ display: 'flex', justifyContent: 'center', flexDirection: 'row',}}>
    <div style={{ justifyContent: 'flex-start', display: 'flex', flexDirection: 'column', backgroundColor: 'grey', padding: '3%'}}>
        <p style={{fontSize: `calc(4px + 1vmin)`, color: 'white', backgroundColor: '#EC3F3F', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}} onClick={CancelSignUpEvents}>Back</p>
        <p style={{fontSize: `calc(4px + 4vmin)`, color: '#D8C0E8', padding: '1%', textAlign: 'center'}}><b>Dear Lecturer, Teacher or Tutor</b></p>
        <p style={{fontSize: `calc(4px + 3vmin)`, color: 'white', backgroundColor: '#BF72C7', padding: '1%', borderRadius: 3, width: 'auto', textAlign: 'center'}}>Reminders</p>

    </div>
<div style={{width: '100%', display: 'flex', flexDirection: 'column',fontSize: `calc(2px + 2vmin)`, padding: '2%'}}>
    <ul>
      <li>Your Sign in details will be  provided by a learners hub representative </li>
      <li><b> When you sign in with this email, You can </b>
         <ul> <li>create accounts for your staffs</li>
              <li>Send important information or updates to your Staffs, students or Alumni based on their course, year or faculty</li>
              <li>Assign staffs to different faculty and courses to enable them to moderate actions there</li>
          </ul>      
      </li>
      
      
    <li> <b>Procedure to get your sign in details </b>
          <ul><li>Send a message the <a href='https://www.instagram.com/inyangraphael/'>learners hub instagram page </a> with your instituitions account to get scheduled for an <i>instagram live video</i></li>
          <li>A learners hub team member will have to spaeak with a representative (vice chancellor, dean of student affairs or proprietor/proprietress) of your educational instituition in the live video </li>
          <li>We will ask them the questions found in the accompanying document</li></ul>
          </li>

    <li>
      <b>Reasons for the live video</b>
      <ul>
        <li><i>We are sure that you will understand the reasons for the live video</i></li>
        <li>Data is already being gathered for your school, as such, we want to be sure that we are handing it over to the school authorities and not some random human</li>
        <li>Your students and staffs will be rest assured that their data is handled by the school authorities</li>
        <li>Announcements and updates will be taken serioously if others knew that it is from the school authority</li>
        <li>The live video is planned to be fun, if you want it so, besides some of your students might want to watch you speak😉</li>
      </ul>
    </li>

    
     


    </ul>
    <Button variant="contained" color="primary" onClick={googleSignIn}>
        Print page
      </Button>
      <Button variant="contained" color="primary" onClick={googleSignIn}>
        Download questionaire
      </Button>
    <Button variant="contained" color="primary" onClick={googleSignIn}>
        Message us
      </Button>
<p style={{padding: '3%', fontSize: `calc(2px + 1vmin)`}}>❤❤❤ Thanks for following the reminders ❤❤❤</p>
</div>
</div>
 </div>
  )
}


      return(
        <div className="Apps">

 {width >= 720 ?<img src={admin} alt="sign in screen" style={{maxHeight: height, maxWidth: '50%'}} />: null}


<div className='communityScreen'> 

<div style={{width: '100%', height: 'auto', justifyContent: 'center', display: 'flex', flexDirection: 'row', }} >
<div style={{backgroundColor: loginColor, color: loginText, height: loginHeight,  paddingLeft: '3%',paddingRight:  '3%', borderTopLeftRadius: 10, borderTopRightRadius: 10,  width: width <= 720 ? '100%' : 'auto' }} onClick={logins} > <p> Login </p></div>
<div style={{backgroundColor: signinColor, color: signinText, height: signinHeight, paddingLeft: '3%',paddingRight:  '3%', borderTopLeftRadius: 10,  borderTopRightRadius: 10,  width: width <= 720 ? '100%' : 'auto'}} onClick={signups} > <p> Sign Up </p> </div>
</div>

<div style={{width: '100%', display: 'flex'}}>
<div style={{display: login, flexDirection:'column', backgroundColor: '#F8EDE3',  padding: '10%', borderRadius: 12, maxWidth: '100%', minWidth: '100%'}}>
<div style={{backgroundColor: 'lightgreen', display: 'flex', border: 1, alignSelf: 'center', alignItems: 'center', borderRadius: 5, alignContent: 'center', padding: '3%', width: '100%', justifyContent: 'center', flexDirection: 'column',}} >

<p> Student/ Alumni Login</p>
<Button variant="contained" color="primary" onClick={googleSignIn}>
        Google Login
      </Button>
      </div>

 <div style={{display: 'flex', alignSelf: 'center', alignItems: 'center', alignContent: 'center', padding: '3%', width: '100%', justifyContent: 'center', flexDirection: 'column',}} >
 <p> As a non-student</p>
 <form  noValidate autoComplete="off">      
 <div style={{display: 'flex', alignSelf: 'center', alignItems: 'center', alignContent: 'center', width: '100%', justifyContent: 'center', flexDirection: 'column',}}>
<TextField
          id="outlined-number"
          label="learners-hub email"
          type="email"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='learners-hub email'
          required
          value = {learnershubemail}
          onChange= {handleChange}
          
        />
<p>Username:- {learnershubemail}</p>
<LoginInstructions/>
        <TextField
          id="outlined-password-input"
          label="Password"
          type="password"
          variant="outlined"
           placeholder='password'
           required
           value = {password}
          onChange= {handlePasswordChange}
         
         
        />


<Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={CustomSignIn}
      >
      Sign In
      </Button>
       
</div>

     
</form>

        </div>

        <div style={{width: '100%', height: 'auto',  justifyContent: 'flex-start', display: 'flex', flexDirection: 'row', fontSize: `calc(4px + 1vmin)`, }}><p style={{width:'auto', borderRadius: 10, paddingLeft: '2%', paddingRight: '2%', backgroundColor: '#D13939', color: 'white'}}>Errors</p><p style={{color: '#D13939'}} >  {errorMessages} <b>{errorCode}</b></p></div>

        </div>

        <div>


  <div style={{display: signup, minWidth: '100%', flexDirection:'column', backgroundColor: '#E3EEF8',  padding: '3%', borderRadius: 12, maxWidth: '100%', height: '100%', justifyContent: 'space-around'}}>

<StudentSignUp/>
<EntrepreneurSignUp/>
<SchoolsSignUp/>
<AcademicsSignUp/>

<div style={{display: signUpDivs, flexDirection:'column', height: '100%', justifyContent: 'space-around'}}>
     <p> Tap on each to learn more about it</p>

     <div onClick={StudentSignUpEvent}>
          <div style={{width: '100%', padding:'1%', height: 'auto', display: 'flex', backgroundColor: '#C0E8C4', borderRadius: 10, flexDirection: 'row', justifyContent: 'flex-start'}}>
              <img src={admin} style={{width: '40vh', height: '15vh', padding: '1%',}} />
              <div style={{width: '100%', height: 'auto',  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>  
                  <p style={{backgroundColor: '#72C77A', color: 'white', width: 'auto', borderRadius: 5, padding: '1%'}}>Students/ Alumni</p> 
                  <p style={{fontSize: `calc(4px + 1vmin)`, color: '#72C77A'}}><i>Students in educational instituitions (tertiary, pre-tertiary or Secondary)</i></p>
              </div>
          </div>     
    </div>

    <div onClick={EntrepreneurSignUpEvent}>
          <div style={{width: '100%', padding:'1%', height: 'auto', display: 'flex', backgroundColor: '#E8E3C0', borderRadius: 10, flexDirection: 'row', justifyContent: 'flex-start'}}>
              <img src={entrepreneur} style={{width: '40vh', height: '15vh', padding: '1%',}} />
              <div style={{width: '100%', height: 'auto',  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>  
                  <p style={{backgroundColor: '#C79F72', color: 'white', width: 'auto', borderRadius: 5, padding: '1%'}}>Entrepreneur</p> 
                  <p style={{fontSize: `calc(4px + 1vmin)`, color: '#C79F72'}}><i>People who run businesses with or without employees</i></p>
              </div>
          </div>     
    </div>


    <div onClick={SchoolsSignUpEvent}>
          <div style={{width: '100%', padding:'1%', height: 'auto', display: 'flex', backgroundColor: '#D8C0E8', borderRadius: 10, flexDirection: 'row', justifyContent: 'flex-start'}}>
              <img src={admin} style={{width: '40vh', height: '15vh', padding: '1%',}} />
              <div style={{width: '100%', height: 'auto',  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>  
                  <p style={{backgroundColor: '#BF72C7', color: 'white', width: 'auto', borderRadius: 5, padding: '1%'}}>Schools</p> 
                  <p style={{fontSize: `calc(4px + 1vmin)`, color: '#BF72C7'}}><i>Educational instituitions (public or private) or Tutorials</i></p>
              </div>
          </div>     
    </div>

    <div onClick={AcademicsSignUpEvent}>
          <div style={{width: '100%', padding:'1%', height: 'auto', display: 'flex', backgroundColor: '#8BA2E1', borderRadius: 10, flexDirection: 'row', justifyContent: 'flex-start'}}>
              <img src={admin} style={{width: '40vh', height: '15vh', padding: '1%',}} />
              <div style={{width: '100%', height: 'auto',  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>  
                  <p style={{backgroundColor: '#3358BE', color: 'white', width: 'auto', borderRadius: 5, padding: '1%'}}>Academics</p> 
                  <p style={{fontSize: `calc(4px + 1vmin)`, color: '#3358BE'}}><i>Teachers in Educational instituitions (public or private) or Tutorials</i></p>
              </div>
          </div>     
    </div>
    </div>

  </div>
</div>
</div>
</div>
</div>
);

     }


     function SignUpScreen () {



      function handleChange(event) {
   setLearnershubemail(event.target.value);
    
  }



  useEffect(() => {
if (learnershubemail.includes("admin")) {
    setErrors(false);
   }else {
    setErrors(true);
   }
 }, [handleChange])

function handlePasswordChange(event) {
   setPassword(event.target.value);
    
  }

useEffect(() => {
if (password.length <= 7) {
    setErrors(true);
   }else {
    setErrors(false);
   }
 }, [handlePasswordChange])

  const [incorrectEntry, setIncorrectEntry] = useState('must include @learnershub.com ')

  async function CustomSignIn () {

     firebase.auth().createUserWithEmailAndPassword(learnershubemail, password).catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // ...
  setErrorMessages(errorMessage);
  setErrorCode(errorCode);
});
   }

      return(
      <div>
 <p> As a non-student</p>
 <form  noValidate autoComplete="off">      
 <TextField
          id="school email"
          label="school email"
          type="email"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          placeholder='School email'
          required
          value = {learnershubemail}
          autoFocus= {true}
          onChange= {handleChange}
          helperText={incorrectEntry}
          error={errors}
        />
<p>{learnershubemail}</p>
        <TextField
          id="school-password"
          label="Password"
          type="password"
          autoComplete="current-password"
          variant="outlined"
           placeholder='password'
           required
           value = {password}
          onChange= {handlePasswordChange}
          error={errors}
          helperText={'must be at least 8 characters and must contain numbers'}
        />

        <Button
        variant="contained"
        color="primary"
        className={classes.button}
        sendIcon={<Icon>send</Icon>}
        onClick={CustomSignIn}
      >
        Send
      </Button>
      <p> errors: 1 - {errorMessages} </p>
      <p> 2- {errorCode}</p>
</form>
        </div>
     )
     }

     return (
     <Router>
 <NoUser exact path='/' />
         <SignUpScreen exact path='SignUp'/>
        
</Router>
     )
    }*/